import React, { useContext, useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PresentPC from 'components/pages/AddConf/PresentPC';
import PresentSP from 'components/pages/AddConf/PresentSP';
import AppContext from 'fluxes/context';

import PcAccordionTextArea from 'components/molecules/PcAccordionTextArea';
import SpAccordionTextArea from 'components/molecules/SpAccordionTextArea';
import PcErrorArea from 'components/molecules/PcErrorArea';
import TextInput from 'components/atoms/Input/TextInput';
import DropdownInput from 'components/atoms/Input/DropdownInput';
import DotSlider from 'components/atoms/Input/DotSlider';

import {
  CHANGE_VALID,
  UPDATE_ADD_CONF,
  UPDATE_RECEIPT_ID,
} from 'fluxes/actions';

import { 
  ekiSuggestApi,
  dutySkillApi,
  postRegisterOrderApi 
} from 'utils/api';

import {
  ADD_THANKS_URL,
  DROPDOWN_INITIAL_ITEM_MAP,
  CHOICES_MAP,
  CHOICES_NAME_MAP,
  ADD_CONF_OD_TITLE_TEXT,
  ADD_INPUT_CONF_TITLE,
  MEASURE_MAP,
  COMMENT_MAP,
  CUSTOM_ERROR_MESSAGES,
} from 'utils/constant';

import {
  useDirectTransCheck,
  useWindowDimensions,
  useIECheck,
  isSchemaValid,
  isCustomValid,
  isFatalApiError,
  MoveCheckStart,
  ErrorMessage,
  sortErrors,
  getChoiceLabel,
  getChoiceValues,
  changeStr,
  randomID,
  scrollTop,
  lockScroll,
  unLockScroll,
  groupByKey,
} from 'utils';
import MeasureEvent from 'utils/measureEvent';

const AddConf = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  const [isApiError, setIsApiError] = useState(false);
  const [showLoading, setShowLoding] = useState(false);

  const history = useHistory();

  // AddInput
  const [bgdOfRecruitment, setBgdOfRecruitment] = useState(state.bgdOfRecruitment);
  const [bgdOfRecruitmentCmnt, setBgdOfRecruitmentCmnt] = useState(state.bgdOfRecruitmentCmnt);
  const [desiredStartDateKubun, setDesiredStartDateKubun] = useState(state.desiredStartDateKubun);
  const [desiredStartDate, setDesiredStartDate] = useState(state.desiredStartDate);
  const [workPeriod, setWorkPeriod] = useState(state.workPeriod);
  const [workPeriodDate, setWorkPeriodDate] = useState(state.workPeriodDate);

  const [isOpenBgdOfRecruitment, setIsOpenBgdOfRecruitment] = useState(false);
  const [isOpenDesiredStartTime, setIsOpenDesiredStartTime] = useState(false);
  const [isOpenWorkPeriod, setIsOpenWorkPeriod] = useState(false);

  const [_selectBgdOfRecruitment, setSelectBgdOfRecruitment] = useState();
  const [_selectBgdOfRecruitmentCmnt, setSelectBgdOfRecruitmentCmnt] = useState('');
  const [_selectDesiredStartDate, setSelectDesiredStartDate] = useState();
  const [_selectDesiredStartDateKubun, setSelectDesiredStartDateKubun] = useState();
  const [_selectWorkPeriod, setSelectWorkPeriod] = useState('');
  const [_selectWorkPeriodDate, setSelectWorkPeriodDate] = useState();

  // AddJobDescription
  const [duty, setDuty] = useState(state.duty);
  const [dutyCmnt, setDutyCmnt] = useState(state.dutyCmnt);
  const [workInfoContent, setWorkInfoContent] = useState(state.workInfoContent);
  const [workInfoContentCmnt, setWorkInfoContentCmnt] = useState(state.workInfoContentCmnt);

  const [apiSkillList, setApiSkillList] = useState(state.apiSkillList);

  const [isOpenDuty, setIsOpenDuty] = useState(false);
  const [isOpenWorkInfo, setIsOpenWorkInfo] = useState(false);
  const [isOpenWICCmnt, setIsOpenWICCmnt] = useState(false);

  const [_modalDuty, setModalDuty] = useState([]);
  const [_modalDutyCmnt, setModalDutyCmnt] = useState('');
  const [_modalWorkInfoContent, setModalWorkInfoContent] = useState([]);
  const [_modalWICShowList, setModalWICShowList] = useState([]);
  const [_modalWICCurrent, setModalWICCurrent] = useState(0);
  const [_modalWICCurrentCtNm, setModalWICCurrentCtNm] = useState('');
  const [_modalWICIsLastBtn, setModalWICIsLastBtn] = useState(false);
  const [_modalWICBtnValid, setModalWICBtnValid] = useState(true);
  const [_modalWICCmnt, setModalWICCmnt] = useState('');

  const [isChangeDuty, setIsChangeDuty] = useState(false);

  // AddSkill
  const [excelSkill, setExcelSkill] = useState(state.excelSkill);
  const [otherSkills, setOtherSkills] = useState(state.otherSkills);
  const [skillOtherCmnt, setSkillOtherCmnt] = useState(state.skillOtherCmnt);

  const [isOpenExcelSkill, setIsOpenExcelSkill] = useState(false);
  const [isOpenOtherSkill, setIsOpenOtherSkill] = useState(false);
  const [isOpenSkillOtherCmnt, setIsOpenSkillOtherCmnt] = useState(false);

  const [_modalExcelSkill, setModalExcelSkill] = useState([]);
  const [_modalOtherSkill, setModalOtherSkill] = useState([]);
  const [_modalSkillOtherCmnt, setModalSkillOtherCmnt] = useState('');

  // AddCondition
  const [ekiCd, setEkiCd] = useState(state.ekiCd);
  const [ekiName, setEkiName] = useState(state.ekiName);
  const [startTime, setStartTime] = useState(state.startTime);
  const [endTime, setEndTime] = useState(state.endTime);
  const [startTimeRangeStart, setStartTimeRangeStart] = useState(state.startTimeRangeStart);
  const [startTimeRangeEnd, setStartTimeRangeEnd] = useState(state.startTimeRangeEnd);
  const [endTimeRangeStart, setEndTimeRangeStart] = useState(state.endTimeRangeStart);
  const [endTimeRangeEnd, setEndTimeRangeEnd] = useState(state.endTimeRangeEnd);
  const [overTimeRange, setOverTimeRange] = useState(state.overTimeRange);
  const [workingDayRange, setWorkingDayRange] = useState(state.workingDayRange);
  const [workingDayRangeOthers, setWorkingDayRangeOthers] = useState(state.workingDayRangeOthers);
  const [workingDayCmnt, setWorkingDayCmnt] = useState(state.workingDayCmnt);
  const [attendance, setAttendance] = useState(state.attendance);
  const [remoteWorkCount, setRemoteWorkCount] = useState(state.remoteWorkCount);
  const [hourSalaryMax, setHourSalaryMax] = useState(state.hourSalaryMax);

  const [isOpenEkiName, setIsOpenEkiName] = useState(false);
  const [isOpenWorkTime, setIsOpenWorkTime] = useState(false);
  const [isOpenStartTimeRange, setIsOpenStartTimeRange] = useState(false);
  const [isOpenEndTimeRange, setIsOpenEndTimeRange] = useState(false);
  const [isOpenOverTime, setIsOpenOverTime] = useState(false);
  const [isOpenWorkDay, setIsOpenWorkDay] = useState(false);
  const [isOpenAttendance, setIsOpenAttendance] = useState(false);
  const [isOpenSalary, setIsOpenSalary] = useState(false);

  const [_modalEkiCd, setModalEkiCd] = useState('');
  const [_modalEkiName, setModalEkiName] = useState('');
  const [_modalEkiSuggestNames, setModalEkiSuggestNames] = useState([]);
  const [_modalStartTime, setModalStartTime] = useState(['','']);
  const [_modalEndTime, setModalEndTime] = useState(['','']);
  const [_modalStartTimeRangeStart, setModalStartTimeRangeStart] = useState(['','']);
  const [_modalStartTimeRangeEnd, setModalStartTimeRangeEnd] = useState(['','']);
  const [_modalEndTimeRangeStart, setModalEndTimeRangeStart] = useState(['','']);
  const [_modalEndTimeRangeEnd, setModalEndTimeRangeEnd] = useState(['','']);
  const [_modalOverTimeRange, setModalOverTimeRange] = useState([]);
  const [_modalWorkingDay, setModalWorkingDay] = useState(['','']);
  const [_modalWorkingDayRangeOthers, setModalWorkingDayRangeOthers] = useState(false);
  const [_modalWorkingDayCmnt, setModalWorkingDayCmnt] = useState('');
  const [_modalAttendance, setModalAttendance] = useState([]);
  const [_modalRemoteWorkCount, setModalRemoteWorkCount] = useState('');
  const [_modalSalaryMax, setModalSalaryMax] = useState(hourSalaryMax.toString());

  const [timerId, setTimerId] = useState('');

  // AddEnvi
  const [welfare, setWelfare] = useState(state.welfare);
  const [welfareCmnt, setWelfareCmnt] = useState(state.welfareCmnt);
  const [workEnvi, setWorkEnvi] = useState(state.workEnvi);
  const [ageRange, setAgeRange] = useState(state.ageRange);
  const [genderRange, setGenderRange] = useState(state.genderRange);
  const [workEnviCmnt, setWorkEnviCmnt] = useState(state.workEnviCmnt);

  const [isOpenWelfare, setIsOpenWelfare] = useState(false);
  const [isOpenWorkEnvi, setIsOpenWorkEnvi] = useState(false);
  const [isOpenAgeRange, setIsOpenAgeRange] = useState(false);
  const [isOpenGenderRange, setIsOpenGenderRange] = useState(false);
  const [isOpenWorkEnviCmnt, setIsOpenWorkEnviCmnt] = useState(false);

  const [_modalWelfare, setModalWelfare] = useState([]);
  const [_modalWelfareCmnt, setModalWelfareCmnt] = useState('');
  const [_modalWorkEnvi, setModalWorkEnvi] = useState([]);
  const [_modalAgeRange, setModalAgeRange] = useState([]);
  const [_modalGenderRange, setModalGenderRange] = useState('');
  const [_modalWorkEnviCmnt, setModalWorkEnviCmnt] = useState('');

  // AddInfo
  const [companyNameText, setCompanyNameText] = useState(state.companyNameText);
  const [dept, setDept] = useState(state.dept);
  const [chargePersonNameText, setChargePersonNameText] = useState(state.chargePersonNameText);
  const [tel, setTel] = useState(state.tel);
  const [email, setEmail] = useState(state.email);
  const [address, setAddress] = useState(state.address);
  const [employmentPlacementDispatching, setEmploymentPlacementDispatching] = useState(state.employmentPlacementDispatching);

  const [isOpenCompanyNameText, setIsOpenCompanyNameText] = useState(false);
  const [isOpenDept, setIsOpenDept] = useState(false);
  const [isOpenChargePersonNameText, setIsOpenChargePersonNameText] = useState(false);
  const [isOpenTel, setIsOpenTel] = useState(false);
  const [isOpenEmail, setIsOpenEmail] = useState(false);
  const [isOpenAddress, setIsOpenAddress] = useState(false);
  const [isOpenEmploymentPlacementDispatching, setIsOpenEmploymentPlacementDispatching] = useState(false);

  const [_modalCompanyNameText, setModalCompanyNameText] = useState('');
  const [_modalDept, setModalDept] = useState('');
  const [_modalChargePersonNameText, setModalChargePersonNameText] = useState('');
  const [_modalTel, setModalTel] = useState('');
  const [_modalEmail, setModalEmail] = useState('');
  const [_modalAddress, setModalAddress] = useState('');
  const [_modalEmploymentPlacementDispatching, setModalEmploymentPlacementDispatching] = useState('');

  // その他フリー入力
  const [otherComment, setOtherComment] = useState(state.otherComment);

  const [receiptID, setReceiptID] = useState(state.receiptID);

  const {
    isAddRegistered,
    clickID,
    mediaID,
    hourSalaryMin,
    hourSalaryApiErr
  } = state;

  const NOT_FILL = <label className='ACONF_nofFill'>未入力</label>;
  const REQUIRE = <label className='ACONF_nofFill'>必ず入力してください</label>;

  /* プルダウン プレースホルダーのセット start */
  // 勤務時間 始業
  const startTimeHourList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeHour, ...CHOICES_MAP.hourList];
  const startTimeMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeMinute, ...CHOICES_MAP.minuteList];

  // 勤務時間 終業
  const endTimeHourList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeHour, ...CHOICES_MAP.hourList];
  const endTimeMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeMinute, ...CHOICES_MAP.minuteList];

  // 始業時間の調整可能範囲
  const startTimeRangeStartHourList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeRangeStartHour, ...CHOICES_MAP.hourList];
  const startTimeRangeStartMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeRangeStartMinute, ...CHOICES_MAP.minuteList];

  const startTimeRangeEndHourList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeRangeEndHour, ...CHOICES_MAP.hourList];
  const startTimeRangeEndMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.startTimeRangeEndMinute, ...CHOICES_MAP.minuteList];

  // 終業時間の調整可能範囲
  const endTimeRangeStartHourList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeRangeStartHour, ...CHOICES_MAP.hourList];
  const endTimeRangeStartMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeRangeStartMinute, ...CHOICES_MAP.minuteList];

  const endTimeRangeEndHourList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeRangeEndHour, ...CHOICES_MAP.hourList];
  const endTimeRangeEndMinuteList = [DROPDOWN_INITIAL_ITEM_MAP.endTimeRangeEndMinute, ...CHOICES_MAP.minuteList];

  // 月の想定残業時間
  const overTimeRangeMinList = [DROPDOWN_INITIAL_ITEM_MAP.overTimeMin, ...CHOICES_MAP.overTimeHourList];
  const overTimeRangeMaxList = [DROPDOWN_INITIAL_ITEM_MAP.overTimeMax, ...CHOICES_MAP.overTimeHourList];

  // 勤務日数の調整可能範囲
  const workingDayRangeMinList = [DROPDOWN_INITIAL_ITEM_MAP.workingDayRangeMin, ...CHOICES_MAP.workingDayRangeList];
  const workingDayRangeMaxList = [DROPDOWN_INITIAL_ITEM_MAP.workingDayRangeMax, ...CHOICES_MAP.workingDayRangeList];

  // 勤務日数の調整可能範囲
  const ageRangeMinList = [DROPDOWN_INITIAL_ITEM_MAP.ageRangeMin, ...CHOICES_MAP.ageList];
  const ageRangeMaxList = [DROPDOWN_INITIAL_ITEM_MAP.ageRangeMax, ...CHOICES_MAP.ageList];
  /* プルダウン プレースホルダーのセット end */

  // 直接遷移チェック
  useDirectTransCheck({ state });
  MoveCheckStart();

  // 依頼ID発行
  useEffect(()=>{
    const id = randomID();
    setReceiptID(`OLOD-${id}`);
  }, []);

  // ブラウザバックを禁止する
  const blockBrowserBack = useCallback(() => {
    window.history.go(1)
  }, [])

  useEffect(() => {
    // 直前の履歴に現在のページを追加
    window.history.pushState(null, null, window.location.href)

    // 直前の履歴と現在のページのループ
    window.addEventListener('popstate', blockBrowserBack)

    // クリーンアップ
    return () => {
      window.removeEventListener('popstate', blockBrowserBack)
    }
  }, [blockBrowserBack])

  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // 入力チェック用変数
  const initialValid = { valid: state.validMap[path], errorMessages: [] };
  const [valids, setValids] = useState({ schema: initialValid });

  const [bgdOfRecruitmentCmntValids, setBgdOfRecruitmentCmntValids] = useState({ bgdOfRecruitmentCmntSchema: initialValid });
  const [desiredStartDateValids, setDesiredStartDateValids] = useState({ desiredStartDateSchema: initialValid });
  const [workPeriodDateValids, setWorkPeriodDateValids] = useState({ workPeriodDateSchema: initialValid });

  const [dutyValids, setDutyValids] = useState({ dutySchema: initialValid });
  const [workInfoContentCmntValids, setWorkInfoContentCmntValids] = useState({ workInfoContentCmntSchema: initialValid });

  const [excelSkillValids, setExcelSkillValids] = useState({ excelSkillSchema: initialValid });
  const [otherSkillValids, setOtherSkillValids] = useState({ otherSkillSchema: initialValid });
  const [skillOtherCmntValids, setSkillOtherCmntValids] = useState({ skillOtherCmntSchema: initialValid });

  const [ekiNameValids, setEkiNameValids] = useState({ ekiNameSchema: initialValid });
  const [workTimeValids, setWorkTimeValids] = useState({ 
    workTimeSchema: initialValid,
    workTimeCheckOverNineSchema: initialValid,
    workTimeCheckEqualSchema: initialValid,
  });
  const [startTimeRangeValids, setStartTimeRangeValids] = useState({ startTimeRangeSchema: initialValid });
  const [endTimeRangeValids, setEndTimeRangeValids] = useState({ endTimeRangeSchema: initialValid });
  const [overTimeValids, setOverTimeValids] = useState({
    overTimeSchema: initialValid,
    overTimeLessThan0Schema: initialValid 
  });
  const [attendanceValids, setAttendanceValids] = useState({ 
    attendanceSchema: initialValid,
    remoteWorkCountSchema: initialValid,
  });
  const [workingDayValids, setWorkingDayValids] = useState({ 
    workingDaySchema: initialValid,
    workingDayCheckLessThan0Schema: initialValid
  });
  const [hourSalaryValids, setHourSalaryValids] = useState({
    hourSalarySchema: initialValid,
    hourSalaryLessThan0Schema: initialValid,
  });

  const [welfareValids, setWelfareValids] = useState({ welfareSchema: initialValid });
  const [workEnviValids, setWorkEnviValids] = useState({ workEnviSchema: initialValid });
  const [ageRangeValids, setAgeRangeValids] = useState({ 
    ageRangeSchema: initialValid,
    ageRangeLessThan0Schema: initialValid 
  });
  const [genderRangeValids, setGenderRangeValids] = useState({ genderRangeSchema: initialValid });
  const [workEnviCmntValids, setWorkEnviCmntValids] = useState({ workEnviCmntSchema: initialValid });

  const [companyNameTextValids, setCompanyNameTextValids] = useState({ companyNameTextSchema: initialValid });
  const [deptValids, setDeptValids] = useState({ deptSchema: initialValid });
  const [chargePersonNameTextValids, setChargePersonNameTextValids] = useState({ chargePersonNameTextSchema: initialValid });
  const [telValids, setTelValids] = useState({ telSchema: initialValid });
  const [emailValids, setEmailValids] = useState({ emailSchema: initialValid });
  const [addressValids, setAddressValids] = useState({ addressSchema: initialValid });
  const [employmentPlacementDispatchingValids, setEmploymentPlacementDispatchingValids] = useState({ employmentPlacementDispatchingSchema: initialValid });

  // 初期入力チェック設定
  const [isShowError, setIsShowError] = useState({
    otherComment: false,

    _selectBgdOfRecruitmentCmnt: false,
   
    _modalDutyCmnt: false,
    _modalWICCmnt: false,

    _modalExcelSkill: false,
    _modalSkillOtherCmnt: false,

    _modalEkiName: false,
    workTime: false,
    _modalStartTimeRangeStart: false,
    _modalStartTimeRangeEnd: false,
    _modalEndTimeRangeStart: false,
    _modalEndTimeRangeEnd: false,
    _modalOverTimeRange: false,
    _modalWorkingDay: false,
    _modalWorkingDayCmnt: false,

    _modalSalaryMax: false,

    _modalWelfare: false,
    _modalWelfareCmnt: false,
    _modalAgeRange: false,
    _modalWorkEnviCmnt: false,

    _modalCompanyNameText: false,
    _modalDept: false,
    _modalChargePersonNameText: false,
    _modalTel: false,
    _modalEmail: false,
    _modalAddress: false,
  });
  // エラーの画面表示で利用する値
  const valid = Object.keys(valids).every(key => valids[key].valid); 
  const dispErrors = useCallback(() => {
    const { schema } = valids;
    const { bgdOfRecruitmentCmntSchema } = bgdOfRecruitmentCmntValids;
    const { desiredStartDateSchema } = desiredStartDateValids;
    const { workPeriodDateSchema } = workPeriodDateValids;

    const { dutySchema } = dutyValids;
    const { workInfoContentCmntSchema } = workInfoContentCmntValids;
  
    const { excelSkillSchema } = excelSkillValids;
    const { otherSkillSchema } = otherSkillValids;
    const { skillOtherCmntSchema } = skillOtherCmntValids;

    const { ekiNameSchema } = ekiNameValids;
    const { workTimeSchema, workTimeCheckOverNineSchema, workTimeCheckEqualSchema } = workTimeValids;
    const { startTimeRangeSchema } = startTimeRangeValids;
    const { endTimeRangeSchema } = endTimeRangeValids;
    const { overTimeSchema, overTimeLessThan0Schema } = overTimeValids;
    const { attendanceSchema, remoteWorkCountSchema } = attendanceValids;
    const { workingDaySchema, workingDayCheckLessThan0Schema } = workingDayValids;
    const { hourSalarySchema, hourSalaryLessThan0Schema } = hourSalaryValids;

    const { welfareSchema } = welfareValids;
    const { workEnviSchema } = workEnviValids;
    const { ageRangeSchema, ageRangeLessThan0Schema } = ageRangeValids;
    const { genderRangeSchema } = genderRangeValids;
    const { workEnviCmntSchema } = workEnviCmntValids;

    const { companyNameTextSchema } = companyNameTextValids;
    const { deptSchema } = deptValids;
    const { chargePersonNameTextSchema } = chargePersonNameTextValids;
    const { telSchema } = telValids;
    const { emailSchema } = emailValids;
    const { addressSchema } = addressValids;
    const { employmentPlacementDispatchingSchema } = employmentPlacementDispatchingValids;
    const errors = sortErrors([
      ...schema.errorMessages,
      ...bgdOfRecruitmentCmntSchema.errorMessages,
      ...desiredStartDateSchema.errorMessages,
      ...workPeriodDateSchema.errorMessages,

      ...dutySchema.errorMessages,
      ...workInfoContentCmntSchema.errorMessages,
      
      ...excelSkillSchema.errorMessages,
      ...otherSkillSchema.errorMessages,
      ...skillOtherCmntSchema.errorMessages,

      ...ekiNameSchema.errorMessages,
      ...workTimeSchema.errorMessages,
      ...workTimeCheckOverNineSchema.errorMessages,
      ...workTimeCheckEqualSchema.errorMessages,
      ...startTimeRangeSchema.errorMessages,
      ...endTimeRangeSchema.errorMessages,
      ...overTimeSchema.errorMessages,
      ...overTimeLessThan0Schema.errorMessages,
      ...attendanceSchema.errorMessages,
      ...remoteWorkCountSchema.errorMessages,
      ...workingDaySchema.errorMessages,
      ...workingDayCheckLessThan0Schema.errorMessages,
      ...hourSalarySchema.errorMessages,
      ...hourSalaryLessThan0Schema.errorMessages,

      ...welfareSchema.errorMessages,
      ...workEnviSchema.errorMessages,
      ...ageRangeSchema.errorMessages,
      ...ageRangeLessThan0Schema.errorMessages,
      ...genderRangeSchema.errorMessages,
      ...workEnviCmntSchema.errorMessages,

      ...companyNameTextSchema.errorMessages,
      ...deptSchema.errorMessages,
      ...chargePersonNameTextSchema.errorMessages,
      ...telSchema.errorMessages,
      ...emailSchema.errorMessages,
      ...addressSchema.errorMessages,
      ...employmentPlacementDispatchingSchema.errorMessages,
    ]);
    const errorMap = errors.reduce((obj, error) => {
      const { target, message } = error;
      if(!isShowError[target] || Object.keys(obj).includes(target)) return obj;
      return { ...obj, [target]: message };
    }, {});
    return errorMap;
  }, [
    isShowError,
    valids,

    bgdOfRecruitmentCmntValids,
    desiredStartDateValids,
    workPeriodDateValids,

    dutyValids,
    workInfoContentCmntValids,

    excelSkillValids,
    skillOtherCmntValids,
    otherSkillValids,

    ekiNameValids,
    workTimeValids,
    startTimeRangeValids,
    endTimeRangeValids,
    overTimeValids,
    attendanceValids,
    workingDayValids,
    hourSalaryValids,

    welfareValids,
    workEnviValids,
    ageRangeValids,
    genderRangeValids,
    workEnviCmntValids,

    companyNameTextValids,
    deptValids,
    chargePersonNameTextValids,
    telValids,
    emailValids,
    addressValids,
    employmentPlacementDispatchingValids,
  ]);

  // 入力チェック（全体）
  useEffect(()=> {
    // エラーチェックを実行
    let [ isValid, newErrorMessages ] = isSchemaValid({
      target: {
        workInfoContent,
        otherComment,
        hourSalaryMin,
        hourSalaryMax,
      },
    });
    // erros更新
    const newValid = { schema: { valid: isValid, errorMessages: newErrorMessages } };
    setValids(org => ({ ...org, ...newValid }));
  }, [
    workInfoContent,
    otherComment,
    hourSalaryMin,
    hourSalaryMax,
  ]);

  // モーダル内入力チェック
  // 募集背景フリーワード
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-bgdOfRecruitmentCmnt`,
      target: {
        _selectBgdOfRecruitment,
        _selectBgdOfRecruitmentCmnt,
      },
    });
    // erros更新
    const newValid = { bgdOfRecruitmentCmntSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setBgdOfRecruitmentCmntValids(org => ({ ...org, ...newValid }));
  }, [ _selectBgdOfRecruitment, _selectBgdOfRecruitmentCmnt, path]);

  // 職種
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-duty`, 
      target: {
        _modalDuty,
        _modalDutyCmnt,
      },
    });
    // erros更新
    const newValid = { dutySchema: { valid: isValid, errorMessages: newErrorMessages } };
    setDutyValids(org => ({ ...org, ...newValid }));
  }, [ _modalDuty, _modalDutyCmnt, path ]);

  // 業務内容フリー入力
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-workInfoContentCmnt`,
      target: {
        _modalWICCmnt,
      },
    });
    // erros更新
    const newValid = { workInfoContentCmntSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWorkInfoContentCmntValids(org => ({ ...org, ...newValid }));
  }, [ _modalWICCmnt, path]);

  // Excelスキル
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-excelSkill`,
      target: {
        _modalExcelSkill,
      },
    });
    // erros更新
    const newValid = { excelSkillSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setExcelSkillValids(org => ({ ...org, ...newValid }));
  }, [ _modalExcelSkill, path]);

  // その他スキル
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-otherSkills`,
      target: {
        _modalOtherSkill,
      },
    });
    // erros更新
    const newValid = { otherSkillSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setOtherSkillValids(org => ({ ...org, ...newValid }));
  }, [ _modalOtherSkill, path]);

  // その他スキルフリー入力
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-skillOtherCmnt`,
      target: {
        _modalSkillOtherCmnt,
      },
    });
    // erros更新
    const newValid = { skillOtherCmntSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setSkillOtherCmntValids(org => ({ ...org, ...newValid }));
  }, [ _modalSkillOtherCmnt, path]);

  // AddCondition
  // 派遣先最寄り駅
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-ekiName`, 
      target: {
        _modalEkiCd,
        _modalEkiName,
      },
    });
    // erros更新
    const newValid = { ekiNameSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setEkiNameValids(org => ({ ...org, ...newValid }));
  }, [ _modalEkiCd, _modalEkiName, path ]);

  // 勤務時間 
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-workTime`, 
      target: {
        _modalStartTime,
        _modalEndTime,
      },
    });
    // erros更新
    const newValid = { workTimeSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWorkTimeValids(org => ({ ...org, ...newValid }));
  }, [ _modalStartTime, _modalEndTime, path ]);
  // 勤務時間 9時間以上エラーチェック
  useEffect(()=>{
    const workTimeValidation = async () => {
      const startTimeConnect = _modalStartTime[0] + _modalStartTime[1];
      const endTimeConnect = _modalEndTime[0] + _modalEndTime[1];
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkOverNine' ],
        target: { target: 'workTime', min: startTimeConnect, max: endTimeConnect },
      });
      // erros更新
      const newValid = { workTimeCheckOverNineSchema: { valid: isValid, errorMessages: newErrorMessages } };
      setWorkTimeValids(org => ({ ...org, ...newValid }));
    };
    workTimeValidation();
  }, [ _modalStartTime, _modalEndTime ]);
  // 勤務時間（始業時間＝終業時間の場合エラー）チェック
  useEffect(()=>{
    const workTimeValidation = async () => {
      const startTimeConnect = _modalStartTime[0] + _modalStartTime[1];
      const endTimeConnect = _modalEndTime[0] + _modalEndTime[1];
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkEqual' ],
        target: { target: 'workTime', min: startTimeConnect, max: endTimeConnect },
      });
      // erros更新
      const newValid = { workTimeCheckEqualSchema: { valid: isValid, errorMessages: newErrorMessages } };
      setWorkTimeValids(org => ({ ...org, ...newValid }));
    };
    workTimeValidation();
  }, [ _modalStartTime, _modalEndTime ]);

  // 始業時間の調整可能範囲 
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-startTimeRange`, 
      target: {
        _modalStartTimeRangeStart,
        _modalStartTimeRangeEnd,
      },
    });
    // erros更新
    const newValid = { startTimeRangeSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setStartTimeRangeValids(org => ({ ...org, ...newValid }));
  }, [ _modalStartTimeRangeStart, _modalStartTimeRangeEnd, path ]);

  // 終業時間の調整可能範囲 
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-endTimeRange`, 
      target: {
        _modalEndTimeRangeStart,
        _modalEndTimeRangeEnd,
      },
    });
    // erros更新
    const newValid = { endTimeRangeSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setEndTimeRangeValids(org => ({ ...org, ...newValid }));
  }, [ _modalEndTimeRangeStart, _modalEndTimeRangeEnd, path ]);

  // 残業時間 
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-overTime`, 
      target: {
        _modalOverTimeRange,
      },
    });
    // erros更新
    const newValid = { overTimeSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setOverTimeValids(org => ({ ...org, ...newValid }));
  }, [ _modalOverTimeRange, path ]);
  // 最大残業時間 - 最小残業時間 < 0
  useEffect(() => {
    const overTimeValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThanZero' ],
        target: { target: '_modalOverTimeRange', min: _modalOverTimeRange[0], max: _modalOverTimeRange[1] },
      });

      // erros更新
      const newValid = { overTimeLessThan0Schema: { valid: isValid, errorMessages: newErrorMessages } };
      setOverTimeValids(org => ({ ...org, ...newValid }));
    };
    overTimeValidation();
  }, [ _modalOverTimeRange ]);

  // 勤務日数の調整可能範囲
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-workDay`,
      target: {
        _modalWorkingDay,
        _modalWorkingDayRangeOthers,
        _modalWorkingDayCmnt
      },
    });
    // erros更新
    const newValid = { workingDaySchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWorkingDayValids(org => ({ ...org, ...newValid }));
  }, [ _modalWorkingDay, _modalWorkingDayRangeOthers, _modalWorkingDayCmnt, path]);
  // 勤務日数の調整可能範囲 最大残業時間 - 最小残業時間 < 0
  useEffect(() => {
    const workingDayValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThanZero' ],
        target: { target: '_modalWorkingDay', min: _modalWorkingDay[0], max: _modalWorkingDay[1] },
      });
      // erros更新
      const newValid = { workingDayCheckLessThan0Schema: { valid: isValid, errorMessages: newErrorMessages } };
      setWorkingDayValids(org => ({ ...org, ...newValid }));
    };
    workingDayValidation();
  }, [ _modalWorkingDay ]);

  // 勤務条件
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-attendance`,
      target: {
        _modalAttendance,
      },
    });
    // erros更新
    const newValid = { attendanceSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setAttendanceValids(org => ({ ...org, ...newValid }));
  }, [_modalAttendance, _modalRemoteWorkCount, path]);
  // 勤務条件 テレワーク可能選択時、テレワークの頻度 必須チェック
  useEffect(() => {
    // エラーチェックを実行.
    const attendanceValidation = async () => {
      // エラーチェックを実行
      const [isValid, newErrorMessages] = await isCustomValid({
        checks: ['checkRemoteWorkCount'],
        target: {
          attendance: _modalAttendance,
          remoteWorkCount: _modalRemoteWorkCount
        },
      });
      // erros更新
      const newValid = { remoteWorkCountSchema: { valid: isValid, errorMessages: newErrorMessages } };
      setAttendanceValids(org => ({ ...org, ...newValid }));
    };
    attendanceValidation();
  }, [_modalAttendance, _modalRemoteWorkCount]);

  // 請求金額
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-hourSalary`, 
      target: {
        _modalSalaryMax,
      },
    });
    // erros更新
    const newValid = { hourSalarySchema: { valid: isValid, errorMessages: newErrorMessages } };
    setHourSalaryValids(org => ({ ...org, ...newValid }));
  }, [ _modalSalaryMax, path ]);
  // 最大請求金額 - 最小請求金額 < 0
  useEffect(() => {
    const hourSalaryValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThanZero' ],
        target: { target: '_modalSalaryMax', min: hourSalaryMin, max: _modalSalaryMax },
      });
      // erros更新
      const newValid = { hourSalaryLessThan0Schema: { valid: isValid, errorMessages: newErrorMessages } };
      setHourSalaryValids(org => ({ ...org, ...newValid }));
    };
    hourSalaryValidation();
  }, [ hourSalaryMin, _modalSalaryMax ]);

  // AddEnvi
  // 福利厚生
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-welfare`,
      target: {
        _modalWelfare,
        _modalWelfareCmnt
      },
    });
    // erros更新
    const newValid = { welfareSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWelfareValids(org => ({ ...org, ...newValid }));
  }, [_modalWelfare, _modalWelfareCmnt, path]);

  // 職場環境の特徴
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-workEnvi`,
      target: {
        _modalWorkEnvi,
      },
    });
    // erros更新
    const newValid = { workEnviSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWorkEnviValids(org => ({ ...org, ...newValid }));
  }, [_modalWorkEnvi, path]);

  // 職場の年齢層
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-ageRange`,
      target: {
        _modalAgeRange
      },
    });
    // erros更新
    const newValid = { ageRangeSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setAgeRangeValids(org => ({ ...org, ...newValid }));
  }, [_modalAgeRange, path]);
  // 最大年齢 - 最小年齢 < 0
  useEffect(() => {
    const ageRangeValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThanZero' ],
        target: { target: '_modalAgeRange', min: _modalAgeRange[0], max: _modalAgeRange[1] },
      });
      // erros更新
      const newValid = { ageRangeLessThan0Schema: { valid: isValid, errorMessages: newErrorMessages } };
      setAgeRangeValids(org => ({ ...org, ...newValid }));
    };
    ageRangeValidation();
  }, [ _modalAgeRange ]);

  // 男女比率
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-genderRange`,
      target: {
        _modalGenderRange
      },
    });
    // erros更新
    const newValid = { genderRangeSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setGenderRangeValids(org => ({ ...org, ...newValid }));
  }, [_modalGenderRange, path]);

  // その他職場環境フリー入力
  useEffect(() => {
    // エラーチェックを実行
    const [isValid, newErrorMessages] = isSchemaValid({
      path: `${path}:modal-workEnviCmnt`,
      target: {
        _modalWorkEnviCmnt,
      },
    });
    // erros更新
    const newValid = { workEnviCmntSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setWorkEnviCmntValids(org => ({ ...org, ...newValid }));
  }, [ _modalWorkEnviCmnt, path]);

  // AddInfo
  // 企業名 
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-companyNameText`, 
      target: {
        _modalCompanyNameText,
      },
    });
    // erros更新
    const newValid = { companyNameTextSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setCompanyNameTextValids(org => ({ ...org, ...newValid }));
  }, [ _modalCompanyNameText, path ]);
    
  // 派遣先部課名
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-dept`, 
      target: {
        _modalDept,
      },
    });
    // erros更新
    const newValid = { deptSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setDeptValids(org => ({ ...org, ...newValid }));
  }, [ _modalDept, path ]);
      
  // ご担当者名
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-chargePersonNameText`, 
      target: {
        _modalChargePersonNameText,
      },
    });
    // erros更新
    const newValid = { chargePersonNameTextSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setChargePersonNameTextValids(org => ({ ...org, ...newValid }));
  }, [ _modalChargePersonNameText, path ]);
      
  // 電話番号
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-tel`, 
      target: {
        _modalTel,
      },
    });
    // erros更新
    const newValid = { telSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setTelValids(org => ({ ...org, ...newValid }));
  }, [ _modalTel, path ]);
      
  // メールアドレス
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-email`, 
      target: {
        _modalEmail,
      },
    });
    // erros更新
    const newValid = { emailSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setEmailValids(org => ({ ...org, ...newValid }));
  }, [ _modalEmail, path ]);
      
  // 派遣先住所
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-address`, 
      target: {
        _modalAddress,
      },
    });
    // erros更新
    const newValid = { addressSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setAddressValids(org => ({ ...org, ...newValid }));
  }, [ _modalAddress, path ]);
      
  // 紹介予定派遣の希望
  useEffect(()=> {
    // エラーチェックを実行
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:modal-employmentPlacementDispatching`, 
      target: {
        _modalEmploymentPlacementDispatching,
      },
    });
    // erros更新
    const newValid = { employmentPlacementDispatchingSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setEmploymentPlacementDispatchingValids(org => ({ ...org, ...newValid }));
  }, [ _modalEmploymentPlacementDispatching, path ]);

  // 相関チェック
  // 就業開始希望日日付指定チェック
  useEffect(()=>{
    const desiredStartDateValidation = async () => {
    // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkDesiredStartDate' ],
        target: { desiredStartDate, desiredStartDateKubun },
      });
      // erros更新
      const newValid = { checkDesiredStartDate: { valid: isValid, errorMessages: newErrorMessages } };
      setDesiredStartDateValids(org => ({ ...org, ...newValid }));
    };
    desiredStartDateValidation();
  }, [ desiredStartDate, desiredStartDateKubun ]);

  // 就業期間日付指定チェック
  useEffect(()=>{
    const workPeriodDateValidation = async () => {
    // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkwWorkPeriodDate' ],
        target: { workPeriodDate, workPeriod },
      });
    
      // erros更新
      const newValid = { checkwWorkPeriodDate: { valid: isValid, errorMessages: newErrorMessages } };
      setWorkPeriodDateValids(org => ({ ...org, ...newValid }));
    };
    workPeriodDateValidation();
  }, [ workPeriodDate, workPeriod ]);

  // モーダル
  /** * 募集背景 モーダル START *** */
  const changeBgdOfRecruitment = () => {
    setSelectBgdOfRecruitment(bgdOfRecruitment);
    setSelectBgdOfRecruitmentCmnt(bgdOfRecruitmentCmnt);
    setIsOpenBgdOfRecruitment(true);
    lockScroll();
  };
  const isCloseBgdOfRecruitment = () => {
    setIsOpenBgdOfRecruitment(false);
    unLockScroll();
  };
  const isSaveBgdOfRecruitment = () => {
    setBgdOfRecruitment(_selectBgdOfRecruitment);
    setBgdOfRecruitmentCmnt(_selectBgdOfRecruitmentCmnt);
    isCloseBgdOfRecruitment();
  };
  // 募集背景 選択
  const onChangeBgdOfRecruitment = (value) => {
    setSelectBgdOfRecruitment(value);
    setSelectBgdOfRecruitmentCmnt('');
  };
  // 募集背景 その他入力
  const onChangeBgdOfRecruitmentCmnt = (e) => {
    setSelectBgdOfRecruitmentCmnt(e.target.value);
    if (!isShowError._selectBgdOfRecruitmentCmnt) {
      setIsShowError({ ...isShowError, _selectBgdOfRecruitmentCmnt: true });
    }
  };
  // モーダル中身
  const bgdOfRecruitmentData = CHOICES_MAP.bgdOfRecruitmentList.map((data) => ({
    id: `bgdOfRecruitment${data.value}`,
    value: data.value,
    onChange: () => onChangeBgdOfRecruitment(data.value),
    label: data.label,
    checked: _selectBgdOfRecruitment === data.value,
    number: isSp ? 2 : 3,
  }));
  const contentBgdOfRecruitment = {
    title: ADD_CONF_OD_TITLE_TEXT.bgdOfRecruitment,
    subTitle: '',
    label: CHOICES_NAME_MAP.require,
    list: bgdOfRecruitmentData,
    type: 'RadioInput',
    comment: {
      title: COMMENT_MAP.bgdOfRecruitmentCmnt.title,
      subTitle: '',
      visible: _selectBgdOfRecruitment === COMMENT_MAP.bgdOfRecruitmentCmnt.value,
      label: CHOICES_NAME_MAP.require,
      questionMark: false,
      popUpTitle: COMMENT_MAP.bgdOfRecruitmentCmnt.popUpTitle,
      popUpDetail: COMMENT_MAP.bgdOfRecruitmentCmnt.popUpDetail,
      relativePosArrow: isSp ? '25%' : null,
      name: 'bgdOfRecruitmentCmnt',
      textAreaValue: _selectBgdOfRecruitmentCmnt,
      cmntOnChange: onChangeBgdOfRecruitmentCmnt,
      onInput: onChangeBgdOfRecruitmentCmnt,
      onCompositionEnd: onChangeBgdOfRecruitmentCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors()._selectBgdOfRecruitmentCmnt,
      inValid: !!dispErrors()._selectBgdOfRecruitmentCmnt,
    },
  };
  // モーダルボタン
  const buttonBgdOfRecruitment = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveBgdOfRecruitment,
    valid: Object.keys(bgdOfRecruitmentCmntValids).every(key => bgdOfRecruitmentCmntValids[key].valid),
  };
  /** * 募集背景 モーダル END *** */

  /** * 就業開始時期 モーダル START *** */
  const changeDesiredStartTime = ()=>{
    setSelectDesiredStartDate(desiredStartDate);
    setSelectDesiredStartDateKubun(desiredStartDateKubun);
    setIsOpenDesiredStartTime(true);
    lockScroll();
  };
  const isCloseDesiredStartTime = () => {
    setIsOpenDesiredStartTime(false);
    unLockScroll();
  };
  const isSaveDesiredStartTime = () => {
    setDesiredStartDate(_selectDesiredStartDate);
    setDesiredStartDateKubun(_selectDesiredStartDateKubun);
    isCloseDesiredStartTime();
  };
  // 就業開始時期 選択
  const onChangeDesireStartDate = (e)=>{
    if (e.target.value === '01' || e.target.value === '02') {
      setSelectDesiredStartDate();
      setSelectDesiredStartDateKubun(e.target.value);
    }
  };
  // 日付選択時イベント
  const handleChangDesiredStartDate = (e, val) => {
    const date = new Date(
      `${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(6)}`,
    );
    setSelectDesiredStartDate(changeStr(date));
    setSelectDesiredStartDateKubun(val);
  };

  // モーダル中身
  const desiredStartDateData = CHOICES_MAP.desiredStartDateKubunList.map((data, index) => ({
    id: `desiredStartDate${ data.value}`,
    value: data.value,
    onChange: onChangeDesireStartDate,
    label: data.label,
    checked: _selectDesiredStartDateKubun === data.value,
    isCalendarRadio: index === 2,
    number: isSp ? 2 : 3,
    handleChange: handleChangDesiredStartDate,
  }));
  const contentDesiredStartTime = {
    title: ADD_CONF_OD_TITLE_TEXT.desiredStartDate,
    subTitle: '',
    label: CHOICES_NAME_MAP.require,
    list: desiredStartDateData,
    type: 'RadioInput',
    selectedDate: desiredStartDate ? new Date(desiredStartDate) : desiredStartDate,
  };
  // モーダルボタン
  const buttonDesiredStartTime = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveDesiredStartTime,
    valid: true,
  };
  /** * 就業開始時期 モーダル END *** */ 

  /** * 就業期間 モーダル START *** */
  const changeWorkPeriod = ()=>{
    setSelectWorkPeriod(workPeriod);
    setSelectWorkPeriodDate(workPeriodDate);
    setIsOpenWorkPeriod(true);
    lockScroll();
  };
  const isCloseWorkPeriod = () => {
    setIsOpenWorkPeriod(false);
    unLockScroll();
  };
  const isSaveWorkPeriod = () => {
    setWorkPeriod(_selectWorkPeriod);
    setWorkPeriodDate(_selectWorkPeriodDate);
    isCloseWorkPeriod();
  };

  // 就業期間 選択
  const onChangeWorkPeriod = (e)=>{
    if (e.target.value === '03' || e.target.value === '02') {
      setSelectWorkPeriodDate();
      setSelectWorkPeriod(e.target.value);
    }
  };
  // 日付選択時イベント
  const handleChangeWorkPeriod = (e, val) => {
    const date = new Date(
      `${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(6)}`,
    );
    setSelectWorkPeriodDate(changeStr(date));
    setSelectWorkPeriod(val);
  };
  // モーダル中身
  const workPeriodData = CHOICES_MAP.workPeriodList.map((data, index) => ({
    id: `workPeriod${ data.value}`,
    value: data.value,
    onChange: onChangeWorkPeriod,
    label: data.label,
    checked: _selectWorkPeriod === data.value,
    isCalendarRadio: index === 2,
    number: isSp ? 2 : 3,
    handleChange: handleChangeWorkPeriod,
  }));
  const contentWorkPeriod = {
    title: ADD_CONF_OD_TITLE_TEXT.workPeriod,
    subTitle: '',
    label: CHOICES_NAME_MAP.require,
    list: workPeriodData,
    type: 'RadioInput',
    selectedDate: workPeriodDate ? new Date(workPeriodDate) : workPeriodDate,
  };
  // モーダルボタン
  const buttonWorkPeriod = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkPeriod,
    valid: true,
  };
  /** * 就業期間 モーダル END *** */

  /** * 職種 モーダル START *** */
  const changeDuty = () => {
    const clone = [...duty];
    setModalDuty(clone);
    setModalDutyCmnt(dutyCmnt);
    setIsOpenDuty(true);
    lockScroll();
  };
  const isCloseDuty = () => {
    setIsChangeDuty(false);
    setIsOpenDuty(false);
    unLockScroll();
  };
  const isSaveDuty = () => {
    setDuty(_modalDuty);
    if (_modalDuty.includes(COMMENT_MAP.dutyCmnt.value)) {
      setDutyCmnt(_modalDutyCmnt);
    } else {
      setDutyCmnt('');
    }
    if (isChangeDuty) {
      setWorkInfoContent([]);
    }
    isCloseDuty();
  };
  // 職種
  const onChangeDuty = (e) => {
    const val = e.target.value;
    if (_modalDuty.includes(e.target.value)) {
      setModalDuty(_modalDuty.filter((item) => item !== val));
      if (val === COMMENT_MAP.dutyCmnt.value) {
        setModalDutyCmnt('');
      }
    } else {
      setModalDuty([..._modalDuty, val]);
    }
    setIsChangeDuty(true);
  };
  const onChangeDutyCmnt = (e) => {
    setModalDutyCmnt(e.target.value);
    if (!isShowError._modalDutyCmnt) {
      setIsShowError({ ...isShowError, _modalDutyCmnt: true });
    }
  };
  // モーダル中身
  const isDutyDisabled = (e) => {
    if (!!_modalDuty && _modalDuty.length >= 2) {
      return !_modalDuty.includes(e);
    } else {
      return false;
    }
  };
  const dutyTitle = () => {
    return <label>職種（選択できるのは<span className='note'>２つまで</span>です）</label>
  }
  const dutyData = CHOICES_MAP.dutyList.map((data) => ({
    id: `duty${data.value}`,
    value: data.value,
    onChange: onChangeDuty,
    label: data.label,
    checked: _modalDuty.includes(data.value),
    disabled: isDutyDisabled(data.value),
  }));
  const contentDuty = {
    title: dutyTitle(),
    subTitle: '',
    label: CHOICES_NAME_MAP.require,
    list: dutyData,
    type: 'BasicCheckBoxInput',
    comment: {
      title: COMMENT_MAP.dutyCmnt.title,
      subTitle: '',
      visible: _modalDuty.includes(COMMENT_MAP.dutyCmnt.value),
      label: CHOICES_NAME_MAP.option,
      questionMark: false,
      popUpTitle: '',
      popUpDetail: '',
      relativePosArrow: '20%',
      name: 'dutyCmnt',
      textAreaValue: _modalDutyCmnt,
      cmntOnChange: onChangeDutyCmnt,
      onInput: onChangeDutyCmnt,
      onCompositionEnd: onChangeDutyCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors()._modalDutyCmnt,
      inValid: !!dispErrors()._modalDutyCmnt,
    },
  };
  // モーダルボタン
  const buttonDuty = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveDuty,
    valid: Object.keys(dutyValids).every(key => dutyValids[key].valid),
  };
  /** * 職種 モーダル END *** */

  /** * 業務内容 モーダル START *** */
  const changeWIC = () => {
    getSkillAPI();
    lockScroll();
  };
  const isCloseWorkInfoModal = () => {
    setModalWICShowList([]);
    setModalWICCurrent(0);
    setIsOpenWorkInfo(false);
    setModalWICBtnValid(true);
    unLockScroll();
  };

  const isSaveWorkInfoContent = () => {
    setWorkInfoContent(_modalWorkInfoContent);
    setModalWICCurrent(0);
    isCloseWorkInfoModal(false);
  };

  const onChangeWorkInfoContent = (value) => {
    if (_modalWorkInfoContent.includes(value)) {
      setModalWorkInfoContent(_modalWorkInfoContent.filter((item) => item !== value));
    } else {
      setModalWorkInfoContent([..._modalWorkInfoContent, value]);
    }
  };

  const onClickBackWorkInfoModal = () => {
    var temp = _modalWICCurrent - 1;
    setModalWICCurrent(temp);
    mapSkill(temp, apiSkillList);
  };

  const onClickNextWorkInfoModal = () => {
    var temp = _modalWICCurrent + 1;
    setModalWICCurrent(temp);

    if (Number(temp) < apiSkillList.length) {
      mapSkill(temp, apiSkillList);
    } else if (_modalWorkInfoContent.length !== 0) {
      isSaveWorkInfoContent();
    }
  };

  useEffect(()=>{
    const isWorkInfoModalLastCat = () => {
      const isLastCat = _modalWICCurrent === apiSkillList.length - 1;
      setModalWICIsLastBtn(isLastCat);
    }
    isWorkInfoModalLastCat();
  }, [_modalWICCurrent, apiSkillList]);

  useEffect(()=>{
    const isValidWorkInfoModalBtn = () => {
      if(!_modalWICIsLastBtn || _modalWorkInfoContent.length > 0) {
        setModalWICBtnValid(true);
      } else {
        setModalWICBtnValid(false);
      }
    }
    isValidWorkInfoModalBtn();
  }, [_modalWICIsLastBtn, _modalWorkInfoContent]);

  const getSkillAPI = () => {
    const id = setTimeout(() => {
      dutySkillApi({ duty }).then((value) => {
        if (!!value) {
          setApiSkillList(value);
          const clone = [...workInfoContent];
          setModalWorkInfoContent(clone);
          setIsOpenWorkInfo(true);
          mapSkill(_modalWICCurrent, value);
        } else {
          setIsApiError(true);
          return false;
        }
      }).catch(err => {
        setIsApiError(true);
        scrollTop();
        return false;
      });
    }, 200, duty);
    return id;
  };

  const mapSkill = (step, skillList) => {
    var temp = [];
    if (!!skillList && skillList.length > 0) {
      setModalWICCurrentCtNm(skillList[step].categoryNm);
      skillList[step].skill.map(skill => (
        temp.push(
          {
            value: skill.skillCd,
            label: skill.skillNm,
            id: 'skill' + skill.skillCd,
          }
        )
      ))
      setModalWICShowList(temp);
    }
  }

  const modalWICShowData = _modalWICShowList.map((data) => ({
    id: data.id,
    value: data.value,
    onChange: () => onChangeWorkInfoContent(data.value),
    label: data.label,
    checked: _modalWorkInfoContent.includes(data.value),
  }));

  // モーダル中身
  const contentWorkInfoModal = {
    title: _modalWICCurrentCtNm,
    subTitle: '',
    label: CHOICES_MAP.option,
    questionMark: false,
    type: 'BasicCheckBoxInput',
    list: modalWICShowData,
  };
  // モーダルボタン
  const btnLabel = _modalWICIsLastBtn ? '完了' : '次へ進む（' + (_modalWICCurrent + 1) + '/' + apiSkillList.length + '）'
  const buttonWorkInfoModal = {
    label: btnLabel,
    onClick: onClickNextWorkInfoModal,
    valid: _modalWICBtnValid,
  };
  /** * 業務内容 モーダル END *** */

  /** * 業務内容その他 モーダル START *** */
  const changeWICCmnt = () => {
    setModalWICCmnt(workInfoContentCmnt);
    setIsOpenWICCmnt(true);
    lockScroll();
  };
  const isCloseWICCmnt = () => {
    setIsOpenWICCmnt(false);
    unLockScroll();
  };
  const isSaveWICCmnt = () => {
    setWorkInfoContentCmnt(_modalWICCmnt);
    isCloseWICCmnt();
  };
  const onChangeWICCmnt = (e) => {
    setModalWICCmnt(e.target.value);
    if (!isShowError._modalWICCmnt) {
      setIsShowError({ ...isShowError, _modalWICCmnt: true });
    }
  };

  // モーダル中身
  const contentWICCmnt = {
    title: '業務内容（自由入力）',
    label: CHOICES_NAME_MAP.option,
    questionMark: false,
    popUpTitle: COMMENT_MAP.workInfoContentCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.workInfoContentCmnt.popUpDetail,
    subTitle: COMMENT_MAP.workInfoContentCmnt.subTitle,
    list: [{
      name: 'workInfoContentCmnt',
      value: _modalWICCmnt,
      onChange: (e) => onChangeWICCmnt(e),
      maxLength: '500',
      wordCount: '(500文字以下)',
      inValid: !!dispErrors()._modalWICCmnt,
    }],
    errMessage: dispErrors()._modalWICCmnt,
    type: 'TextAreaInput',
  };
  // モーダルボタン
  const buttonWICCmnt = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWICCmnt,
    valid: Object.keys(workInfoContentCmntValids).every(key => workInfoContentCmntValids[key].valid),
  };
  /** * 業務内容その他 モーダル END *** */

  /** * Excelスキル モーダル START *** */
  const changeExcelSkill = () => {
    const clone = [...excelSkill];
    setModalExcelSkill(clone);
    setIsOpenExcelSkill(true);
    lockScroll();
  };
  const isCloseExcelSkill = () => {
    setIsOpenExcelSkill(false);
    unLockScroll();
  };
  const isSaveExcelSkill = () => {
    setExcelSkill(_modalExcelSkill);
    isCloseExcelSkill();
  };
  // Excelスキル 選択
  const onChangeExcelSkill = (value) => {
    if (_modalExcelSkill.includes(value)) {
      setModalExcelSkill(_modalExcelSkill.filter((item) => item !== value));
    } else {
      setModalExcelSkill([..._modalExcelSkill, value]);
    }
    if (!isShowError._modalExcelSkill) {
      setIsShowError({ ...isShowError, _modalExcelSkill: true });
    }
  };
  // モーダル中身
  const excelSkillData = CHOICES_MAP.excelskillList.map((data) => ({
    id: `excelSkill${data.value}`,
    value: data.value,
    onChange: () => onChangeExcelSkill(data.value),
    label: data.label,
    number: isSp ? 2 : 3.1,
    checked: _modalExcelSkill.includes(data.value),
  }));
  const contentExcelSkill = {
    title: ADD_CONF_OD_TITLE_TEXT.excelSkill,
    subTitle: '',
    label: '必須',
    list: excelSkillData,
    type: 'BasicCheckBoxInput',
  };
  // モーダルボタン
  const buttonExcelSkill = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveExcelSkill,
    valid: Object.keys(excelSkillValids).every(key => excelSkillValids[key].valid),
  };
  /** * Excelスキル モーダル END *** */

  /** * Otherスキル モーダル START *** */
  const changeOtherSkill = () => {
    const clone = [...otherSkills];
    setModalOtherSkill(clone);
    setIsOpenOtherSkill(true);
    lockScroll();
  };
  const isCloseOtherSkill = () => {
    setIsOpenOtherSkill(false);
    unLockScroll();
  };
  const isSaveOtherSkill = () => {
    setOtherSkills(_modalOtherSkill);
    isCloseOtherSkill();
  };
  // Otherスキル 選択
  const onChangeOtherSkill = (value) => {
    if (_modalOtherSkill.includes(value)) {
      setModalOtherSkill(_modalOtherSkill.filter((item) => item !== value));
    } else {
      setModalOtherSkill([..._modalOtherSkill, value]);
    }
  };
  // モーダル中身
  const otherSkillData = CHOICES_MAP.otherSkillsList.map((data) => ({
    id: `otherSkill${data.value}`,
    value: data.value,
    onChange: () => onChangeOtherSkill(data.value),
    label: data.label,
    number: isSp ? 2 : 3.1,
    checked: _modalOtherSkill.includes(data.value),
  }));
  const contentOtherSkill = {
    title: ADD_CONF_OD_TITLE_TEXT.otherSkill,
    subTitle: '',
    label: CHOICES_NAME_MAP.option,
    list: otherSkillData,
    type: 'BasicCheckBoxInput',
  };
  // モーダルボタン
  const buttonOtherSkill = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveOtherSkill,
    valid: Object.keys(otherSkillValids).every(key => otherSkillValids[key].valid),
  };
  /** * Otherスキル モーダル END *** */

  /** * その他スキル モーダル START *** */
  const changeSkillOtherCmnt = () => {
    setModalSkillOtherCmnt(skillOtherCmnt);
    setIsOpenSkillOtherCmnt(true);
    lockScroll();
  };
  const isCloseSkillOtherCmnt = () => {
    setIsOpenSkillOtherCmnt(false);
    unLockScroll();
  };
  const isSaveSkillOtherCmnt = () => {
    setSkillOtherCmnt(_modalSkillOtherCmnt);
    isCloseSkillOtherCmnt();
  };
  const onChangeSkillOtherCmnt = (e) => {
    setModalSkillOtherCmnt(e.target.value);
    if (!isShowError._modalSkillOtherCmnt) {
      setIsShowError({ ...isShowError, _modalSkillOtherCmnt: true });
    }
  };
  // モーダル中身
  const skillOtherCmntTitle = isSp ? COMMENT_MAP.skillOtherCmnt.title
    : 'その他、ご希望のスキルや経験について、\n必要な場面や理由を含めて教えてください';
  const contentSkillOtherCmnt = {
    title: skillOtherCmntTitle,
    subTitle: COMMENT_MAP.skillOtherCmnt.subTitle,
    label: CHOICES_NAME_MAP.option,
    questionMark: false,
    popUpTitle: COMMENT_MAP.skillOtherCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.skillOtherCmnt.popUpDetail,
    list: [{
      name: 'skillOtherCmnt',
      value: _modalSkillOtherCmnt,
      onChange: (e) => onChangeSkillOtherCmnt(e),
      maxLength: '500',
      rows: '10',
      cols: '100',
      placeholder: COMMENT_MAP.skillOtherCmnt.placeholder,
      wordCount: '(500文字以下)',
      inValid: !!dispErrors()._modalSkillOtherCmnt,
    } ],
    type: 'TextAreaInput',
  };
  // モーダルボタン 
  const buttonSkillOtherCmnt = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveSkillOtherCmnt,
    valid: Object.keys(skillOtherCmntValids).every(key => skillOtherCmntValids[key].valid),
  };
  /** * その他スキル モーダル END *** */

  /** * 派遣先最寄り駅 モーダル START *** */
  const changeEkiName = () => {
    setModalEkiCd(ekiCd);
    setModalEkiName(ekiName);
    setIsOpenEkiName(true);
    lockScroll();
  };
  const isCloseEkiName = () => {
    setModalEkiSuggestNames([]);
    setIsOpenEkiName(false);
    unLockScroll();
  };
  const isSaveEkiName = () => {
    setEkiCd(_modalEkiCd);
    setEkiName(_modalEkiName);
    isCloseEkiName();
  };
  const onChangeEkiName = async (e) => {
    setModalEkiName(e.target.value);
    if (!isShowError._modalEkiName) {
      setIsShowError({ ...isShowError, _modalEkiName: true });
    }
    // safariのdeleteCompositionTextを無視
    if (e.nativeEvent.inputType === 'deleteCompositionText' || e.nativeEvent.inputType === 'insertFromComposition') {
      return;
    }

    const searchText = e.target.value;
    setModalEkiName(searchText);
    setModalEkiCd('');

    // 先行タイマー停止
    clearTimeout(timerId);
    // タイマー設定
    setTimerId(await ekiSuggestTimer(searchText));
  };

  // 駅入力
  // サジェスト表示タイマー
  const ekiSuggestTimer = async (searchText) => {
    const id = setTimeout(() => {
      ekiSuggestApi({ searchText }).then((value) => {
        setModalEkiSuggestNames(value);
        // サジェストあり
        if (value.length > 0) {
          const newValid = {
            ekiNameSchema: {
              valid: false,
              errorMessages: [],
            },
          };
          setEkiNameValids(org => ({ ...org, ...newValid }));
        }
      }).catch(err => {
        // FATELエラーチェック
        const isFatal = isFatalApiError(err);
        setIsApiError(isFatal);
        if (isFatal) throw err;
        // 駅サジェスト0件
        if (err.response.status === 404) {
          setModalEkiSuggestNames([]);
          // erros更新
          const newValid = {
            ekiNameSchema: {
              valid: false,
              errorMessages: [new ErrorMessage('_modalEkiName', CUSTOM_ERROR_MESSAGES.ekiSuggestZero, 1)],
            },
          };
          setEkiNameValids(org => ({ ...org, ...newValid }));
        }
        return [];
      });
      // ekiNameエラー表示開始
      if (!isShowError._modalEkiName) {
        setIsShowError({
          ...isShowError,
          ...{
            _modalEkiName: true,
            _modalEkiCd: true,
          },
        });
      }
    }, 200, searchText);
    return id;
  };

  // 駅サジェストクリック時
  const onClickEkiSuggest = async (idx) => {
    const clicked = _modalEkiSuggestNames[idx];
    setModalEkiName(clicked.ekiNm);
    setModalEkiCd(clicked.ekiCd);
    setModalEkiSuggestNames([]);
  };

  // モーダル中身
  const contentEkiName = {
    title: CHOICES_NAME_MAP.ekiName,
    subTitle: '派遣スタッフ就業先の最寄り駅を選択してください。なお、一部地域については、対応できない場合がございます。',
    label: '必須',
    questionMark: false,
    type: 'TextInput',
    list: [{
      name: 'ekiName',
      value: _modalEkiName,
      onChange: (e) => onChangeEkiName(e),
      placeholder: '駅名',
      inValid: !!dispErrors()._modalEkiName,
      suggestText: false,
      suggestList: {
        items: _modalEkiSuggestNames.map(x => x.ekiNm),
        onClick: onClickEkiSuggest,
      }
    }],
  };
  // モーダルボタン
  const buttonEkiName = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveEkiName,
    valid: Object.keys(ekiNameValids).every(key => ekiNameValids[key].valid),
  };
  /** * 派遣先最寄り駅 モーダル END *** */


  /** * 勤務時間 モーダル START *** */
  const changeWorkTime = () => {
    const s = [...startTime];
    setModalStartTime(s);
    const e = [...endTime];
    setModalEndTime(e);
    setIsOpenWorkTime(true);
    lockScroll();
  };
  const isCloseWorkTime = () => {
    setIsOpenWorkTime(false);
    unLockScroll();
  };
  const isSaveWorkTime = () => {
    setStartTime(_modalStartTime);
    setEndTime(_modalEndTime);
    isCloseWorkTime();
  };
  const onChangeStartTimeHour = (value)=>{
    setModalStartTime(_modalStartTime.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError.workTime) {
      setIsShowError({ ...isShowError, workTime: true });
    }
  };
  const onChangeStartTimeMinute = (value)=>{
    setModalStartTime(_modalStartTime.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError.workTime) {
      setIsShowError({ ...isShowError, workTime: true });
    }
  };
  const onChangeEndTimeHour = (value)=>{
    setModalEndTime(_modalEndTime.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError.workTime) {
      setIsShowError({ ...isShowError, workTime: true });
    }
  };
  const onChangeEndTimeMinute = (value)=>{
    setModalEndTime(_modalEndTime.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError.workTime) {
      setIsShowError({ ...isShowError, workTime: true });
    }
  };

  // モーダル中身
  const contentWorkTime = {
    title: '勤務時間',
    subTitle: '実働8時間以内（休憩1時間の場合、始業時間から終業時間まで9時間以内）で入力してください。',
    label: '必須',
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    list: <>
      <div className='workTime'>
        <span className='workTime_DB'>
          <DropdownInput
            items={startTimeHourList}
            selectedValue={_modalStartTime[0]}
            onChange={onChangeStartTimeHour}
            isOpen={false}
            inValid={!!dispErrors().workTime}
          />
        </span>
        <label>時</label>
        <span className='workTime_DB'>
          <DropdownInput
            items={startTimeMinuteList}
            selectedValue={_modalStartTime[1]}
            onChange={onChangeStartTimeMinute}
            isOpen={false}
            inValid={!!dispErrors().workTime}
          />
        </span>
        <label>分</label>{isSp ? <br /> : <></>}
        <label>～</label>
        <span className='workTime_DB'>
          <DropdownInput
            items={endTimeHourList}
            selectedValue={_modalEndTime[0]}
            onChange={onChangeEndTimeHour}
            isOpen={false}
            inValid={!!dispErrors().workTime}
          />
        </span>
        <label>時</label>
        <span className='workTime_DB'>
          <DropdownInput
            items={endTimeMinuteList}
            selectedValue={_modalEndTime[1]}
            onChange={onChangeEndTimeMinute}
            isOpen={false}
            inValid={!!dispErrors().workTime}
          />
        </span>
        <label>分</label>
        <span className=''>
          <PcErrorArea position='absolute' message={dispErrors().workTime} />
        </span>
      </div>
    </>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonWorkTime = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkTime,
    valid: Object.keys(workTimeValids).every(key => workTimeValids[key].valid),
  };
  /** * 勤務時間 モーダル END *** */

  /** * 始業時間の調整可能範囲 モーダル START *** */
  const changeStartTimeRange = () => {
    const s = [...startTimeRangeStart];
    setModalStartTimeRangeStart(s);
    const e = [...startTimeRangeEnd];
    setModalStartTimeRangeEnd(e);
    setIsOpenStartTimeRange(true);
    lockScroll();
  };
  const isCloseStartTimeRange = () => {
    setIsOpenStartTimeRange(false);
    unLockScroll();
  };
  const isSaveStartTimeRange = () => {
    setStartTimeRangeStart(_modalStartTimeRangeStart);
    setStartTimeRangeEnd(_modalStartTimeRangeEnd);
    isCloseStartTimeRange();
  };
  const onChangeStartTimeRangeStartHour = (value)=>{
    setModalStartTimeRangeStart(_modalStartTimeRangeStart.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError._modalStartTimeRangeStart) {
      setIsShowError({ ...isShowError, _modalStartTimeRangeStart: true });
    }
  };
  const onChangeStartTimeRangeStartMinute = (value)=>{
    setModalStartTimeRangeStart(_modalStartTimeRangeStart.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError._modalStartTimeRangeStart) {
      setIsShowError({ ...isShowError, _modalStartTimeRangeStart: true });
    }
  };
  const onChangeStartTimeRangeEndHour = (value)=>{
    setModalStartTimeRangeEnd(_modalStartTimeRangeEnd.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError._modalStartTimeRangeEnd) {
      setIsShowError({ ...isShowError, _modalStartTimeRangeEnd: true });
    }
  };
  const onChangeStartTimeRangeEndMinute = (value)=>{
    setModalStartTimeRangeEnd(_modalStartTimeRangeEnd.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError._modalStartTimeRangeEnd) {
      setIsShowError({ ...isShowError, _modalStartTimeRangeEnd: true });
    }
  };
  // モーダル中身
  const contentStartTimeRange = {
    title: '始業時間の調整可能範囲',
    subTitle: '',
    label: CHOICES_NAME_MAP.option,
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    list: <>
      <div className='startTimeRange'>
        <span className='startTimeRange_DB'>
          <DropdownInput
            items={startTimeRangeStartHourList}
            selectedValue={_modalStartTimeRangeStart[0]}
            onChange={onChangeStartTimeRangeStartHour}
            isOpen={false}
            inValid={!!dispErrors()._modalStartTimeRangeStart}
          />
        </span>
        <label>時</label>
        <span className='startTimeRange_DB'>
          <DropdownInput
            items={startTimeRangeStartMinuteList}
            selectedValue={_modalStartTimeRangeStart[1]}
            onChange={onChangeStartTimeRangeStartMinute}
            isOpen={false}
            inValid={!!dispErrors()._modalStartTimeRangeStart}
          />
        </span>
        <label>分</label>{isSp ? <br /> : <></>}
        <label>～</label>
        <span className='startTimeRange_DB'>
          <DropdownInput
            items={startTimeRangeEndHourList}
            selectedValue={_modalStartTimeRangeEnd[0]}
            onChange={onChangeStartTimeRangeEndHour}
            isOpen={false}
            inValid={!!dispErrors()._modalStartTimeRangeEnd}
          />
        </span>
        <label>時</label>
        <span className='startTimeRange_DB'>
          <DropdownInput
            items={startTimeRangeEndMinuteList}
            selectedValue={_modalStartTimeRangeEnd[1]}
            onChange={onChangeStartTimeRangeEndMinute}
            isOpen={false}
            inValid={!!dispErrors()._modalStartTimeRangeEnd}
          />
        </span>
        <label>分</label>
      </div>
    </>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonStartTimeRange = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveStartTimeRange,
    valid: Object.keys(startTimeRangeValids).every(key => startTimeRangeValids[key].valid),
  };
  /** * 始業時間の調整可能範囲 モーダル END *** */

  /** * 終業時間の調整可能範囲 モーダル START *** */
  const changeEndTimeRange = () => {
    const s = [...endTimeRangeStart];
    setModalEndTimeRangeStart(s);
    const e = [...endTimeRangeEnd];
    setModalEndTimeRangeEnd(e);
    setIsOpenEndTimeRange(true);
    lockScroll();
  };
  const isCloseEndTimeRange = () => {
    setIsOpenEndTimeRange(false);
    unLockScroll();
  };
  const isSaveEndTimeRange = () => {
    setEndTimeRangeStart(_modalEndTimeRangeStart);
    setEndTimeRangeEnd(_modalEndTimeRangeEnd);
    isCloseEndTimeRange();
  };
  const onChangeEndTimeRangeStartHour = (value)=>{
    setModalEndTimeRangeStart(_modalEndTimeRangeStart.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError._modalEndTimeRangeStart) {
      setIsShowError({ ...isShowError, _modalEndTimeRangeStart: true });
    }
  };
  const onChangeEndTimeRangeStartMinute = (value)=>{
    setModalEndTimeRangeStart(_modalEndTimeRangeStart.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError._modalEndTimeRangeStart) {
      setIsShowError({ ...isShowError, _modalEndTimeRangeStart: true });
    }
  };
  const onChangeEndTimeRangeEndHour = (value)=>{
    setModalEndTimeRangeEnd(_modalEndTimeRangeEnd.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError._modalEndTimeRangeEnd) {
      setIsShowError({ ...isShowError, _modalEndTimeRangeEnd: true });
    }
  };
  const onChangeEndTimeRangeEndMinute = (value)=>{
    setModalEndTimeRangeEnd(_modalEndTimeRangeEnd.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError._modalEndTimeRangeEnd) {
      setIsShowError({ ...isShowError, _modalEndTimeRangeEnd: true });
    }
  };
  // モーダル中身
  const contentEndTimeRange = {
    title: '終業時間の調整可能範囲',
    subTitle: '',
    label: CHOICES_NAME_MAP.option,
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    list: <>
      <div className='endTimeRange'>
        <span className='endTimeRange_DB'>
          <DropdownInput
            items={endTimeRangeStartHourList}
            selectedValue={_modalEndTimeRangeStart[0]}
            onChange={onChangeEndTimeRangeStartHour}
            isOpen={false}
            inValid={!!dispErrors()._modalEndTimeRangeStart}
          />
        </span>
        <label>時</label>
        <span className='endTimeRange_DB'>
          <DropdownInput
            items={endTimeRangeStartMinuteList}
            selectedValue={_modalEndTimeRangeStart[1]}
            onChange={onChangeEndTimeRangeStartMinute}
            isOpen={false}
            inValid={!!dispErrors()._modalEndTimeRangeStart}
          />
        </span>
        <label>分</label>{isSp ? <br /> : <></>}
        <label>～</label>
        <span className='endTimeRange_DB'>
          <DropdownInput
            items={endTimeRangeEndHourList}
            selectedValue={_modalEndTimeRangeEnd[0]}
            onChange={onChangeEndTimeRangeEndHour}
            isOpen={false}
            inValid={!!dispErrors()._modalEndTimeRangeEnd}
          />
        </span>
        <label>時</label>
        <span className='endTimeRange_DB'>
          <DropdownInput
            items={endTimeRangeEndMinuteList}
            selectedValue={_modalEndTimeRangeEnd[1]}
            onChange={onChangeEndTimeRangeEndMinute}
            isOpen={false}
            inValid={!!dispErrors()._modalEndTimeRangeEnd}
          />
        </span>
        <label>分</label>
      </div>
    </>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonEndTimeRange = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveEndTimeRange,
    valid: Object.keys(endTimeRangeValids).every(key => endTimeRangeValids[key].valid),
  };
  /** * 終業時間の調整可能範囲 モーダル END *** */

  /** * 残業時間 モーダル START *** */
  const changeOverTime = () => {
    const clone = [...overTimeRange];
    setModalOverTimeRange(clone);
    setIsOpenOverTime(true);
    lockScroll();
  };
  const isCloseOverTime = () => {
    setIsOpenOverTime(false);
    unLockScroll();
  };
  const isSaveOverTime = () => {
    setOverTimeRange(_modalOverTimeRange);
    isCloseOverTime();
  };
  const onChangeOverTimeRangeStart = (value)=>{
    setModalOverTimeRange(_modalOverTimeRange.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError._modalOverTimeRange) {
      setIsShowError({ ...isShowError, _modalOverTimeRange: true });
    }
  };
  const onChangeOverTimeRangeEnd = (value)=>{
    setModalOverTimeRange(_modalOverTimeRange.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError._modalOverTimeRange) {
      setIsShowError({ ...isShowError, _modalOverTimeRange: true });
    }
  };

  // モーダル中身
  const contentOverTime = {
    title: '月の想定残業時間',
    subTitle: '所定時間外についての残業時間を選択してください。',
    label: '必須',
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    list: <>
      <div className='overTimeRange'>
        <span className='overTimeRange_DB'>
          <DropdownInput
            items={overTimeRangeMinList}
            selectedValue={_modalOverTimeRange[0]}
            onChange={onChangeOverTimeRangeStart}
            isOpen={false}
            inValid={!!dispErrors()._modalOverTimeRange}
          />
        </span>
        <label>時間</label>
        <label>～</label>
        <span className='overTimeRange_DB'>
          <DropdownInput
            items={overTimeRangeMaxList}
            selectedValue={_modalOverTimeRange[1]}
            onChange={onChangeOverTimeRangeEnd}
            isOpen={false}
            inValid={!!dispErrors()._modalOverTimeRange}
          />
        </span>
        <label>時間</label>
        <span className=''>
          <PcErrorArea position='absolute' message={dispErrors()._modalOverTimeRange} />
        </span>
      </div>
    </>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonOverTime = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveOverTime,
    valid: Object.keys(overTimeValids).every(key => overTimeValids[key].valid),
  };
  /** * 残業時間 モーダル END *** */

  /** * 勤務日 モーダル START *** */
  const changeWorkDay = () => {
    setModalWorkingDay(workingDayRange);
    setModalWorkingDayRangeOthers(workingDayRangeOthers);
    setModalWorkingDayCmnt(workingDayCmnt);
    setIsOpenWorkDay(true);
    lockScroll();
  };
  const isCloseWorkDay = () => {
    setIsOpenWorkDay(false);
    unLockScroll();
  };
  const isSaveWorkDay = () => {
    setWorkingDayRange(_modalWorkingDay);
    setWorkingDayRangeOthers(_modalWorkingDayRangeOthers);
    setWorkingDayCmnt(_modalWorkingDayCmnt);
    isCloseWorkDay();
  };
  const onChangeWorkingDayRangeStart = (value)=>{
    setModalWorkingDay(_modalWorkingDay.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError._modalWorkingDay) {
      setIsShowError({ ...isShowError, _modalWorkingDay: true });
    }
  };
  const onChangeWorkingDayRangeEnd = (value)=>{
    setModalWorkingDay(_modalWorkingDay.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError._modalWorkingDay) {
      setIsShowError({ ...isShowError, _modalWorkingDay: true });
    }
  };
  const onChangeWorkingDayRangeOthers = () =>{
    if (_modalWorkingDayRangeOthers) {
      setModalWorkingDayRangeOthers(false);
      setModalWorkingDayCmnt('');
    } else {
      setModalWorkingDayRangeOthers(true);
      setModalWorkingDay(['', '']);
    } 
  };
  const onChangeWorkingDayCmnt = (e) => {
    setModalWorkingDayCmnt(e.target.value);
    if(!isShowError._modalWorkingDayCmnt) {
      setIsShowError({ ...isShowError, _modalWorkingDayCmnt: true });
    }
  };

  // モーダル中身
  const workingDayRangeOthersDisp = {
    value: _modalWorkingDayRangeOthers,
    label: 'その他（シフト勤務など）',
    onChange: onChangeWorkingDayRangeOthers,
    checked: _modalWorkingDayRangeOthers,
    id: 'workingDayRangeOthersCmnt',
    comment: {
      title: COMMENT_MAP.workingDayRangeOthersCmnt.title,
      subTitle: '',
      label: CHOICES_NAME_MAP.require,
      name: 'workingDayRangeOthersCmnt',
      textAreaValue: _modalWorkingDayCmnt,
      cmntOnChange: onChangeWorkingDayCmnt,
      onInput: onChangeWorkingDayCmnt,
      onCompositionEnd: onChangeWorkingDayCmnt,
      maxLength: '500',
      placeholder: COMMENT_MAP.workingDayRangeOthersCmnt.placeholder,
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      visible: _modalWorkingDayRangeOthers,
      questionMark: false,
      popUpTitle: null,
      popUpDetail: null,
      errMessage: dispErrors()._modalWorkingDayCmnt,
      inValid: !!dispErrors()._modalWorkingDayCmnt,
    },
  };
  const contentWorkDay = {
    title: '勤務日数の調整可能範囲',
    subTitle: '',
    label: '必須',
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    list: <>
      <div className='workingDayRange'>
        <div className='dropDown'>
          <label className='syuu'>平日週</label>
          <span className='workingDayRange_DB'>
            <DropdownInput
              items={workingDayRangeMinList}
              selectedValue={_modalWorkingDay[0]}
              disabled={_modalWorkingDayRangeOthers}
              onChange={onChangeWorkingDayRangeStart}
              isOpen={false}
              inValid={!!dispErrors()._modalWorkingDay}
            />
          </span>
          <label>日</label>
          <label>～</label>
          <span className='workingDayRange_DB'>
            <DropdownInput
              items={workingDayRangeMaxList}
              selectedValue={_modalWorkingDay[1]}
              disabled={_modalWorkingDayRangeOthers}
              onChange={onChangeWorkingDayRangeEnd}
              isOpen={false}
              inValid={!!dispErrors()._modalWorkingDay}
            />
          </span>
          <label>日</label>
        </div>
        <span className=''>
          <PcErrorArea position='absolute' message={dispErrors()._modalWorkingDay} />
        </span>
        <div className="workingDayRangeOthersDisp">
          {isSp ?
            <SpAccordionTextArea
              value={workingDayRangeOthersDisp.value}
              label={workingDayRangeOthersDisp.label}
              checkBoxOnChange={workingDayRangeOthersDisp.onChange}
              checked={workingDayRangeOthersDisp.checked}
              id={workingDayRangeOthersDisp.id}
              textAreaTitle={workingDayRangeOthersDisp.comment.title}
              textAreaLabel={workingDayRangeOthersDisp.comment.label}
              name={workingDayRangeOthersDisp.comment.name}
              textAreaValue={workingDayRangeOthersDisp.comment.textAreaValue}
              cmntOnChange={workingDayRangeOthersDisp.comment.cmntOnChange}
              onInput={workingDayRangeOthersDisp.comment.onInput}
              onCompositionEnd={workingDayRangeOthersDisp.comment.onCompositionEnd}
              maxLength={workingDayRangeOthersDisp.comment.maxLength}
              placeholder={workingDayRangeOthersDisp.comment.placeholder}
              rows={workingDayRangeOthersDisp.comment.rows}
              cols={workingDayRangeOthersDisp.comment.cols}
              wordCount={workingDayRangeOthersDisp.comment.wordCount}
              inValid={workingDayRangeOthersDisp.comment.inValid}
              errPosition='relative'
              errMessage={workingDayRangeOthersDisp.comment.errMessage}
            /> :
            <PcAccordionTextArea
              value={workingDayRangeOthersDisp.value}
              label={workingDayRangeOthersDisp.label}
              checkBoxOnChange={workingDayRangeOthersDisp.onChange}
              checked={workingDayRangeOthersDisp.checked}
              id={workingDayRangeOthersDisp.id}
              textAreaTitle={workingDayRangeOthersDisp.comment.title}
              textAreaLabel={workingDayRangeOthersDisp.comment.label}
              name={workingDayRangeOthersDisp.comment.name}
              textAreaValue={workingDayRangeOthersDisp.comment.textAreaValue}
              cmntOnChange={workingDayRangeOthersDisp.comment.cmntOnChange}
              onInput={workingDayRangeOthersDisp.comment.onInput}
              onCompositionEnd={workingDayRangeOthersDisp.comment.onCompositionEnd}
              maxLength={workingDayRangeOthersDisp.comment.maxLength}
              placeholder={workingDayRangeOthersDisp.comment.placeholder}
              rows={workingDayRangeOthersDisp.comment.rows}
              cols={workingDayRangeOthersDisp.comment.cols}
              wordCount={workingDayRangeOthersDisp.comment.wordCount}
              inValid={workingDayRangeOthersDisp.comment.inValid}
              errPosition={workingDayRangeOthersDisp.comment.errPosition}
              errMessage={workingDayRangeOthersDisp.comment.errMessage}
            />}
        </div>
      </div>
    </>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonWorkDay = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkDay,
    valid: Object.keys(workingDayValids).every(key => workingDayValids[key].valid),
  };
  /** * 勤務日 モーダル END *** */

  /** * 勤務条件 モーダル START *** */
  const changeAttendance = () => {
    setModalAttendance(attendance);
    setModalRemoteWorkCount(remoteWorkCount);
    setIsOpenAttendance(true);
    lockScroll();
  };
  const isCloseAttendance = () => {
    setIsOpenAttendance(false);
    unLockScroll();
  };
  const isSaveAttendance = () => {
    setAttendance(_modalAttendance);
    setRemoteWorkCount(_modalRemoteWorkCount);
    isCloseAttendance();
  };
  const onChangeAttendance = (e) => {
    const val = e.target.value;
    if (_modalAttendance.includes(val)) {
      setModalAttendance(_modalAttendance.filter((item) => item !== val));
    } else {
      setModalAttendance([ ..._modalAttendance, val ]);
    }
    if(!_modalAttendance.includes('03')){
      setModalRemoteWorkCount('');
    }
  };
  const onChangeRemoteWorkCount = (e) => {
    setModalRemoteWorkCount(e.target.value);
  };

  const contentAttendance = {
    title: '該当する場合はチェックをつけてください',
    subTitle: '',
    label: CHOICES_NAME_MAP.option,
    list: CHOICES_MAP.attendanceList.map((elem) => {
      const infoStr = 'attendance';
      return {
        id: infoStr + elem.value,
        value: elem.value,
        onChange: onChangeAttendance,
        checked: _modalAttendance ? _modalAttendance.includes(elem.value) : false,
        label: elem.label,
        name: infoStr,
        number: isSp ? 2 : 3.04,
      };
    }),
    type: 'CheckBoxChildInput',
    childInput: _modalAttendance.includes('03') ? {
      title: 'テレワークの頻度を選択してください',
      subTitle: '',
      label: CHOICES_NAME_MAP.require,      
      type: 'RadioInput',
      visible: _modalAttendance ? _modalAttendance.includes('03') : false,
      list: CHOICES_MAP.remoteWorkCountList.map((elem) => {
        const infoStr = 'remoteWorkCount';
        return {
          value: elem.value,
          label: elem.label,
          id: infoStr + elem.value,
          onChange: onChangeRemoteWorkCount,
          checked: _modalRemoteWorkCount ? _modalRemoteWorkCount.includes(elem.value) : false,
          name: infoStr,
          number: isSp ? null : 3,
        };
      }),
    }: null,
  };
  // モーダルボタン
  const buttonAttendance = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveAttendance,
    valid: Object.keys(attendanceValids).every(key => attendanceValids[key].valid),
  };
  /** * 勤務条件 モーダル END *** */

  /** * 請求金額 モーダル START *** */
  const changeSalary = () => {
    setModalSalaryMax(hourSalaryMax.toString());
    setIsOpenSalary(true);
    lockScroll();
  };
  const isCloseSalary = () => {
    setIsOpenSalary(false);
    unLockScroll();
  };
  const isSaveSalary = () => {
    setHourSalaryMax(Number(_modalSalaryMax));
    isCloseSalary();
  };
  // 請求金額
  const onChangeHourSalaryMax = (e) => {
    setModalSalaryMax(e.target.value);
    if (!isShowError._modalSalaryMax) {
      setIsShowError({ ...isShowError, _modalSalaryMax: true });
    }
  };

  // モーダル中身
  const contentSalary = {
    title: '請求金額目安（1時間当たり）',
    subTitle: '※交通費は別途ご請求となります',
    label: '必須',
    list:
      <span className='ACONF_hourSalary'>
        <label><span className='min'>{hourSalaryMin}</span> ～ </label>
        <TextInput
          name='_modalSalaryMax'
          val={_modalSalaryMax}
          onChange={(e) => onChangeHourSalaryMax(e)}
          onInput={(e) => onChangeHourSalaryMax(e)}
          onCompositionEnd={(e) => onChangeHourSalaryMax(e)}
          maxLength='4'
          placeholder=''
          inValid={!!dispErrors()._modalSalaryMax}
        />
        <label>円/時間</label>
        <span className='ACONF_ERR'>
          <PcErrorArea position='' message={dispErrors()._modalSalaryMax} />
        </span>
        <span className='ACONF_ERR_API'>
          <PcErrorArea position='' message={hourSalaryApiErr} />
        </span>
      </span>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonSalary = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveSalary,
    valid: Object.keys(hourSalaryValids).every(key => hourSalaryValids[key].valid),
  };
  /** * 請求金額 モーダル END *** */

  /** * 福利厚生 モーダル START *** */
  const changeWelfare = () => {
    const clone = [...welfare];
    setModalWelfare(clone);
    setModalWelfareCmnt(welfareCmnt);
    setIsOpenWelfare(true);
    lockScroll();
  };
  const isCloseWelfare = () => {
    setIsOpenWelfare(false);
    unLockScroll();
  };
  const isSaveWelfare = () => {
    setWelfare(_modalWelfare);
    if(!_modalWelfare.includes('05')) {
      setWelfareCmnt('');
    } else {
      setWelfareCmnt(_modalWelfareCmnt);
    }
    isCloseWelfare();
  };
  // 募集背景 選択
  const onChangeWelfare = (value) => {
    if (value === '09') {
      // 該当なし以外を消す
      if (_modalWelfare.includes(value)) {
        setModalWelfare([]);
      } else {
        setModalWelfare(['09']);
      }
      setModalWelfareCmnt('');
    } else {
      // 該当なしを消す
      if (_modalWelfare.includes('09')) {
        setModalWelfare(_modalWelfare.splice(_modalWelfare.indexOf('09'), 1));
      }
      if (_modalWelfare.includes(value)) {
        setModalWelfare(_modalWelfare.filter(item => item !== value));
        if (value === '05') {
          setModalWelfareCmnt('');
        }
      } else {
        setModalWelfare([..._modalWelfare, value]);
      }
    }
    if (!isShowError._modalWelfare) {
      setIsShowError({ ...isShowError, _modalWelfare: true });
    }
  };
  const onChangeWelfareCmnt = (e) => {
    setModalWelfareCmnt(e.target.value);
    if (!isShowError._modalWelfareCmnt) {
      setIsShowError({ ...isShowError, _modalWelfareCmnt: true });
    }
  };
  // モーダル中身
  const isWelfareDisabled = (e) => {
    if (!!_modalWelfare && _modalWelfare.includes('09')) {
      return !_modalWelfare.includes(e);
    } else {
      return false;
    }
  };
  const welfareData = CHOICES_MAP.welfareList.map((data) => ({
    id: `welfare${data.value}`,
    value: data.value,
    onChange: () => onChangeWelfare(data.value),
    label: data.label,
    checked: _modalWelfare.includes(data.value),
    disabled: isWelfareDisabled(data.value),
    number: isSp ? 2 : 3.1,
  }));
  const contentWelfare = {
    title: ADD_INPUT_CONF_TITLE.welfare,
    subTitle: '',
    label: '必須',
    list: welfareData,
    type: 'BasicCheckBoxInput',
    // 福利厚生施設 テキストエリア
    comment: {
      title: '福利厚生施設を掲載してください',
      subTitle: '',
      visible: _modalWelfare.includes('05'),
      label: '必須',
      questionMark: false,
      popUpTitle: '',
      popUpDetail: '',
      relativePosArrow: isSp ? '25%' : '45%',
      name: 'welfareCmnt',
      textAreaValue: _modalWelfareCmnt,
      cmntOnChange: onChangeWelfareCmnt,
      onInput: onChangeWelfareCmnt,
      onCompositionEnd: onChangeWelfareCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors()._modalWelfareCmnt,
      inValid: !!dispErrors()._modalWelfareCmnt,
    },
  };
  // モーダルボタン
  const buttonWelfare = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWelfare,
    valid: Object.keys(welfareValids).every(key => welfareValids[key].valid),
  };
  /** * 福利厚生 モーダル END *** */

  /** * 職場環境の特徴 モーダル START *** */
  const changeWorkEnvi = () => {
    const clone = [...workEnvi];
    setModalWorkEnvi(clone);
    setIsOpenWorkEnvi(true);
    lockScroll();
  };
  const isCloseWorkEnvi = () => {
    setIsOpenWorkEnvi(false);
    unLockScroll();
  };
  const isSaveWorkEnvi = () => {
    setWorkEnvi(_modalWorkEnvi);
    isCloseWorkEnvi();
  };
  const onChangeWorkEnvi = (e) => {
    const val = e.target.value;
    if (_modalWorkEnvi.includes(val)) {
      setModalWorkEnvi(_modalWorkEnvi.filter((item) => item !== val));
    } else {
      setModalWorkEnvi([..._modalWorkEnvi, val]);
    }
  };
  // モーダル中身
  const contentWorkEnvi = {
    title: ADD_INPUT_CONF_TITLE.workEnvi,
    subTitle: '',
    label: CHOICES_NAME_MAP.option,
    list: CHOICES_MAP.workEnviList.map((elem) => {
      const infoStr = 'workEnvi';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: onChangeWorkEnvi,
        checked: _modalWorkEnvi.includes(elem.value),
      };
    }),
    type: 'CheckBoxInput',
  };
  // モーダルボタン 
  const buttonWorkEnvi = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkEnvi,
    valid: Object.keys(workEnviValids).every(key => workEnviValids[key].valid),
  };
  /** * 職場環境の特徴 モーダル END *** */

  /** * 職場の年齢層 モーダル START *** */
  const changeAgeRange = () => {
    const clone = [...ageRange];
    setModalAgeRange(clone);
    setIsOpenAgeRange(true);
    lockScroll();
  };
  const isCloseAgeRange = () => {
    setIsOpenAgeRange(false);
    unLockScroll();
  };
  const isSaveAgeRange = () => {
    setAgeRange(_modalAgeRange);
    isCloseAgeRange();
  };
  const onChangeAgeRangeMin = (value)=>{
    setModalAgeRange(_modalAgeRange.map((list, index) => (index === 0 ? value : list)));
    if(!isShowError._modalAgeRange) {
      setIsShowError({ ...isShowError, _modalAgeRange: true });
    }
  };
  const onChangeAgeRangeMax = (value)=>{
    setModalAgeRange(_modalAgeRange.map((list, index) => (index === 1 ? value : list)));
    if(!isShowError._modalAgeRange) {
      setIsShowError({ ...isShowError, _modalAgeRange: true });
    }
  };
  // モーダル中身
  const contentAgeRange = {
    title: '職場の年齢層',
    subTitle: '',
    label: '必須',
    questionMark: false,
    popUpTitle: null,
    popUpDetail: null,
    list: <>
      <div className='ageRange'>
        <span className='ageRange_DB'>
          <DropdownInput
            items={ageRangeMinList}
            selectedValue={_modalAgeRange[0]}
            onChange={onChangeAgeRangeMin}
            isOpen={false}
            inValid={!!dispErrors()._modalAgeRange}
          />
        </span>
        <label>代</label>
        <label>～</label>
        <span className='ageRange_DB'>
          <DropdownInput
            items={ageRangeMaxList}
            selectedValue={_modalAgeRange[1]}
            onChange={onChangeAgeRangeMax}
            isOpen={false}
            inValid={!!dispErrors()._modalAgeRange}
          />
        </span>
        <label>代</label>
        <span className=''>
          <PcErrorArea position='absolute' message={dispErrors()._modalAgeRange} />
        </span>
      </div>
    </>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonAgeRange = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveAgeRange,
    valid: Object.keys(ageRangeValids).every(key => ageRangeValids[key].valid),
  };
  /** * 職場の年齢層 モーダル END *** */

  /** * 男女比率 モーダル START *** */
  const changeGenderRange = () => {
    setModalGenderRange(genderRange);
    setIsOpenGenderRange(true);
    lockScroll();
  };
  const isCloseGenderRange = () => {
    setIsOpenGenderRange(false);
    unLockScroll();
  };
  const isSaveGenderRange = () => {
    setGenderRange(_modalGenderRange);
    isCloseGenderRange();
  };
  const onChangeGenderRange = (e) => {
    const val = e.target.value;
    setModalGenderRange(val);
  };
  // モーダル中身
  const genderRangeData = CHOICES_MAP.genderRangeList.map((data) => ({
    id: `gender${data.value}`,
    value: data.value,
    label: data.label,
    checked: _modalGenderRange.includes(data.value),
    onChange: onChangeGenderRange
  }));
  const contentGenderRange = {
    title: '男女比率',
    label: CHOICES_NAME_MAP.require,
    questionMark: false,
    popUpTitle: '',
    popUpDetail: '',
    subTitle: '',
    list: 
      <>
        <div className="genderRange">
          <DotSlider
            items={genderRangeData}
            onChange={onChangeGenderRange}
            name="genderRange"
          />
        </div>
      </>,
    type: 'FreeInput',
  };
  // モーダルボタン
  const buttonGenderRange = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveGenderRange,
    valid: Object.keys(genderRangeValids).every(key => genderRangeValids[key].valid),
  };
  /** * 男女比率 モーダル END *** */

  /** * 職場環境_その他 モーダル START *** */
  const changeWorkEnviCmnt = () => {
    setModalWorkEnviCmnt(workEnviCmnt);
    setIsOpenWorkEnviCmnt(true);
    lockScroll();
  };
  const isCloseWorkEnviCmnt = () => {
    setIsOpenWorkEnviCmnt(false);
    unLockScroll();
  };
  const isSaveWorkEnviCmnt = () => {
    setWorkEnviCmnt(_modalWorkEnviCmnt);
    isCloseWorkEnviCmnt();
  };
  const onChangeWorkEnviCmnt = (e) => {
    setModalWorkEnviCmnt(e.target.value);
    if (!isShowError._modalWorkEnviCmnt) {
      setIsShowError({ ...isShowError, _modalWorkEnviCmnt: true });
    }
  };
  // モーダル中身
  const contentWorkEnviCmnt = {
    title: '職場環境（自由入力）',
    subTitle: '',
    label: CHOICES_NAME_MAP.option,
    questionMark: false,
    popUpTitle: '',
    popUpDetail: '',
    list: [{
      name: 'workEnviCmnt',
      value: _modalWorkEnviCmnt,
      onChange: (e) => onChangeWorkEnviCmnt(e),
      maxLength: '500',
      rows: '10',
      cols: '100',
      wordCount: '(500文字以下)',
      inValid: !!dispErrors()._modalWorkEnviCmnt,
    }],
    type: 'TextAreaInput',
  };
  // モーダルボタン 
  const buttonWorkEnviCmnt = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveWorkEnviCmnt,
    valid: Object.keys(workEnviCmntValids).every(key => workEnviCmntValids[key].valid),
  };
  /** * 職場環境_その他 モーダル END *** */

  /** * 企業名 モーダル START *** */
  const changeCompanyNameText = () => {
    setModalCompanyNameText(companyNameText);
    setIsOpenCompanyNameText(true);
    lockScroll();
  };
  const isCloseCompanyNameText = () => {
    setIsOpenCompanyNameText(false);
    unLockScroll();
  };
  const isSaveCompanyNameText = () => {
    setCompanyNameText(_modalCompanyNameText);
    isCloseCompanyNameText();
  };
  const onChangeCompanyNameText = (e) => {
    setModalCompanyNameText(e.target.value);
    if (!isShowError._modalCompanyNameText) {
      setIsShowError({ ...isShowError, _modalCompanyNameText: true });
    }
  };

  // モーダル中身
  const contentCompanyNameText = {
    title: CHOICES_NAME_MAP.companyNameText,
    subTitle: '',
    label: '必須',
    questionMark: false,
    type: 'TextInput',
    list: [{
      name: 'companyNameText',
      value: _modalCompanyNameText,
      onChange: (e) => onChangeCompanyNameText(e),
      placeholder: '株式会社リクルートスタッフィング',
      maxLength: '300',
      inValid: !!dispErrors()._modalCompanyNameText,
      suggestText: false
    }],
  };
  // モーダルボタン
  const buttonCompanyNameText = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveCompanyNameText,
    valid: Object.keys(companyNameTextValids).every(key => companyNameTextValids[key].valid),
  };
  /** * 企業名 モーダル END *** */

  /** * 派遣先部課名 モーダル START *** */
  const changeDept = () => {
    setModalDept(dept);
    setIsOpenDept(true);
    lockScroll();
  };
  const isCloseDept = () => {
    setIsOpenDept(false);
    unLockScroll();
  };
  const isSaveDept = () => {
    setDept(_modalDept);
    isCloseDept();
  };
  const onChangeDept = (e) => {
    setModalDept(e.target.value);
    if (!isShowError._modalDept) {
      setIsShowError({ ...isShowError, _modalDept: true });
    }
  };

  // モーダル中身
  const contentDept = {
    title: CHOICES_NAME_MAP.dept,
    subTitle: '',
    label: '必須',
    questionMark: true,
    popUpTitle: COMMENT_MAP.deptCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.deptCmnt.popUpDetail,
    type: 'TextInput',
    list: [{
      name: 'dept',
      value: _modalDept,
      onChange: (e) => onChangeDept(e),
      placeholder: '人事部　人事課',
      maxLength: '150',
      inValid: !!dispErrors()._modalDept,
      suggestText: false
    }],
  };
  // モーダルボタン
  const buttonDept = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveDept,
    valid: Object.keys(deptValids).every(key => deptValids[key].valid),
  };
  /** * 派遣先部課名 モーダル END *** */

  /** * ご担当者名 モーダル START *** */
  const changeChargePersonNameText = () => {
    setModalChargePersonNameText(chargePersonNameText);
    setIsOpenChargePersonNameText(true);
    lockScroll();
  };
  const isCloseChargePersonNameText = () => {
    setIsOpenChargePersonNameText(false);
    unLockScroll();
  };
  const isSaveChargePersonNameText = () => {
    setChargePersonNameText(_modalChargePersonNameText);
    isCloseChargePersonNameText();
  };
  const onChangeChargePersonNameText = (e) => {
    setModalChargePersonNameText(e.target.value);
    if (!isShowError._modalChargePersonNameText) {
      setIsShowError({ ...isShowError, _modalChargePersonNameText: true });
    }
  };

  // モーダル中身
  const contentChargePersonNameText = {
    title: CHOICES_NAME_MAP.chargePersonNameText,
    subTitle: '',
    label: '必須',
    questionMark: false,
    type: 'TextInput',
    list: [{
      name: 'chargePersonNameText',
      value: _modalChargePersonNameText,
      onChange: (e) => onChangeChargePersonNameText(e),
      placeholder: '派遣　太郎',
      maxLength: '150',
      inValid: !!dispErrors()._modalChargePersonNameText,
      suggestText: false
    }],
  };
  // モーダルボタン
  const buttonChargePersonNameText = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveChargePersonNameText,
    valid: Object.keys(chargePersonNameTextValids).every(key => chargePersonNameTextValids[key].valid),
  };
  /** * ご担当者名 モーダル END *** */

  /** * 電話番号 モーダル START *** */
  const changeTel = () => {
    setModalTel(tel);
    setIsOpenTel(true);
    lockScroll();
  };
  const isCloseTel = () => {
    setIsOpenTel(false);
    unLockScroll();
  };
  const isSaveTel = () => {
    setTel(_modalTel);
    isCloseTel();
  };
  const onChangeTel = (e) => {
    setModalTel(e.target.value);
    if (!isShowError._modalTel) {
      setIsShowError({ ...isShowError, _modalTel: true });
    }
  };

  // モーダル中身
  const contentTel = {
    title: CHOICES_NAME_MAP.tel,
    subTitle: '',
    label: '必須',
    questionMark: false,
    type: 'TextInput',
    list: [{
      name: 'tel',
      value: _modalTel,
      onChange: (e) => onChangeTel(e),
      placeholder: '090123456789',
      maxLength: '13',
      inValid: !!dispErrors()._modalTel,
      suggestText: false
    }],
  };
  // モーダルボタン
  const buttonTel = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveTel,
    valid: Object.keys(telValids).every(key => telValids[key].valid),
  };
  /** * 電話番号 モーダル END *** */

  /** * メールアドレス モーダル START *** */
  const changeEmail = () => {
    setModalEmail(email);
    setIsOpenEmail(true);
    lockScroll();
  };
  const isCloseEmail = () => {
    setIsOpenEmail(false);
    unLockScroll();
  };
  const isSaveEmail = () => {
    setEmail(_modalEmail);
    isCloseEmail();
  };
  const onChangeEmail = (e) => {
    setModalEmail(e.target.value);
    if (!isShowError._modalEmail) {
      setIsShowError({ ...isShowError, _modalEmail: true });
    }
  };

  // モーダル中身
  const contentEmail = {
    title: CHOICES_NAME_MAP.email,
    subTitle: '',
    label: '必須',
    questionMark: false,
    type: 'TextInput',
    list: [{
      name: 'email',
      value: _modalEmail,
      onChange: (e) => onChangeEmail(e),
      placeholder: 'haken@r-staffing.co.jp',
      inValid: !!dispErrors()._modalEmail,
      suggestText: false
    }],
  };
  // モーダルボタン
  const buttonEmail = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveEmail,
    valid: Object.keys(emailValids).every(key => emailValids[key].valid),
  };
  /** * メールアドレス モーダル END *** */

  /** * 派遣先住所 モーダル START *** */
  const changeAddress = () => {
    setModalAddress(address);
    setIsOpenAddress(true);
    lockScroll();
  };
  const isCloseAddress = () => {
    setIsOpenAddress(false);
    unLockScroll();
  };
  const isSaveAddress = () => {
    setAddress(_modalAddress);
    isCloseAddress();
  };
  const onChangeAddress = (e) => {
    setModalAddress(e.target.value);
    if (!isShowError._modalAddress) {
      setIsShowError({ ...isShowError, _modalAddress: true });
    }
  };

  // モーダル中身
  const contentAddress = {
    title: CHOICES_NAME_MAP.address,
    subTitle: '派遣スタッフが実際に就業する住所を、番地・建物名まで記載してください。',
    label: '必須',
    questionMark: false,
    type: 'TextInput',
    list: [{
      name: 'address',
      value: _modalAddress,
      onChange: (e) => onChangeAddress(e),
      placeholder: '都道府県・市区町村・丁目番地・ビル名',
      maxLength: '300',
      inValid: !!dispErrors()._modalAddress,
      suggestText: false
    }],
  };
  // モーダルボタン
  const buttonAddress = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveAddress,
    valid: Object.keys(addressValids).every(key => addressValids[key].valid),
  };
  /** * 派遣先住所 モーダル END *** */

  /** * 紹介予定派遣の希望 モーダル START *** */
  const changeEmploymentPlacementDispatching = () => {
    setModalEmploymentPlacementDispatching(employmentPlacementDispatching);
    setIsOpenEmploymentPlacementDispatching(true);
    lockScroll();
  };
  const isCloseEmploymentPlacementDispatching = () => {
    setIsOpenEmploymentPlacementDispatching(false);
    unLockScroll();
  };
  const isSaveEmploymentPlacementDispatching = () => {
    setEmploymentPlacementDispatching(_modalEmploymentPlacementDispatching);
    isCloseEmploymentPlacementDispatching();
  };
  const onChangeEmploymentPlacementDispatching = (e) => {
    if (_modalEmploymentPlacementDispatching) {
      setModalEmploymentPlacementDispatching(false);
    } else {
      setModalEmploymentPlacementDispatching(true);
    }
  };

  // モーダル中身
  const employmentPlacementDispatchingData = {
    id: `employmentPlacementDispatching${_modalEmploymentPlacementDispatching}`,
    value: _modalEmploymentPlacementDispatching,
    onChange: onChangeEmploymentPlacementDispatching,
    label: "紹介予定派遣のみをご希望の方はこちらをチェックしてください",
    checked: _modalEmploymentPlacementDispatching,
  };

  const contentEmploymentPlacementDispatching = {
    title: '紹介予定派遣のみの希望',
    subTitle: '',
    label: '任意',
    questionMark: true,
    popUpTitle: '紹介予定派遣について',
    popUpDetail: (
      <>
        「紹介予定派遣」とは、社員として採用することを前提に、派遣社員を一定期間受入、派遣期間中に社員としての適性を見極めることができる仕組みです。
        <br />
        <br />
        詳細は
        <a className="link-grey" href="/sol/contents/client/ttoh/" target="_blank" rel="noopener noreferrer">こちら</a>
      </>
    ),
    type: 'BasicCheckBoxOnly',
    list: employmentPlacementDispatchingData,
  };
  // モーダルボタン
  const buttonEmploymentPlacementDispatching = {
    label: ADD_CONF_OD_TITLE_TEXT.buttonChange,
    onClick: isSaveEmploymentPlacementDispatching,
    valid: true,
  };
  /** * 紹介予定派遣の希望 モーダル END *** */

  // onChange 連絡事項
  const onChangeOtherComment = (e) =>{
    setOtherComment(e.target.value);
    if(!isShowError.otherComment) {
      setIsShowError({ ...isShowError, otherComment: true });
    }
  };

  // 画面項目
  const getBgdOfRecruitment = () => {
    if(bgdOfRecruitment === ''){
      return (
        NOT_FILL
      );
    } 
    const target = CHOICES_MAP.bgdOfRecruitmentList.find(v=>v.value === bgdOfRecruitment);
    return <label>{bgdOfRecruitment === COMMENT_MAP.bgdOfRecruitmentCmnt.value? bgdOfRecruitmentCmnt : target.label}</label>;
  };

  const getDesiredStartDate = () => {
    const target = CHOICES_MAP.desiredStartDateKubunList.find(v=>v.value === desiredStartDateKubun);
    if(desiredStartDateKubun === ''){
      return (
        NOT_FILL
      );
    }    
    if(desiredStartDateKubun === '03'){
      return (`${String(desiredStartDate).split('/')[0]}年${String(desiredStartDate).split('/')[1]}月${String(desiredStartDate).split('/')[2]}日`);
    }
    return(target.label);
  };

  const getWorkPeriod = () => {
    const target = CHOICES_MAP.workPeriodList.find(v=>v.value === workPeriod);
    if(workPeriod === ''){
      return (
        NOT_FILL
      );
    }    
    if(workPeriod === '01'){
      return (`${String(workPeriodDate).split('/')[0]}年${String(workPeriodDate).split('/')[1]}月${String(workPeriodDate).split('/')[2]}日`);
    }
    return(target.label);
  };

  const getDuty = () => {
    let str = getChoiceValues('dutyList')
      .filter(v => duty.includes(v))
      .map(v => getChoiceLabel('dutyList', v))
      .join(' / ');
    if (!!dutyCmnt && dutyCmnt !== '') {
      str += '\n\n「その他事務」' + dutyCmnt;
    }
    return (str);
  }

  const getJD = () => {
    let selectedSkill = [];
    if (!!workInfoContent && workInfoContent.length > 0) {
      apiSkillList.forEach(function (cat) {
        cat.skill.forEach(function (skill) {
          if (workInfoContent.includes(skill.skillCd)) {
            if (cat.categoryKindKbn === '1') {
              selectedSkill.push({
                category: '業務内容',
                skillCd: skill.skillCd,
                skillNm: skill.skillNm
              })
            } else {
              selectedSkill.push({
                category: cat.categoryNm,
                skillCd: skill.skillCd,
                skillNm: skill.skillNm
              })
            }
          }
        })
      });

      let printByCategory = [];
      printByCategory = groupByKey(selectedSkill, 'category');

      let str = '';
      for (var key in printByCategory) {
        if (printByCategory.hasOwnProperty(key)) {
          var arr = printByCategory[key];
          var _temp = [];
          arr.forEach(function (item) {
            if (item) {
              _temp.push(item.skillNm);
            }
          })

          key !== '業務内容' ? str += '\n\n' : str += '';
          str += `(${key})\n`;
          str += `${_temp.join(", ")}`;
        }
      }
      return (str);
    } else {
      return <>{REQUIRE}</>
    }
  };

  const getWICCmnt = () => {
    return (
      <span>
        {workInfoContentCmnt === '' ? NOT_FILL : <label>{workInfoContentCmnt}</label>}
      </span>
    );
  };

  const getExcel = () => {
    const str = getChoiceValues('excelskillList')
      .filter(v => excelSkill.includes(v))
      .map(v => getChoiceLabel('excelskillList', v))
      .join(' / ');
    return (str);
  }

  const getOtherSkill = () => {
    const str = getChoiceValues('otherSkillsList')
      .filter(v => otherSkills.includes(v))
      .map(v => getChoiceLabel('otherSkillsList', v))
      .join(' / ');
    
    return (str === '' ? NOT_FILL : str);
  }

  const getSkillOtherCmnt = () => {
    return (
      <span>
        {skillOtherCmnt === '' ? NOT_FILL : <label>{skillOtherCmnt}</label>}
      </span>
    );
  };

  const getWorkTime = () => {
    if (!!startTime && !!endTime) {
      return (
        <span className=''>
          {startTime[0]}時{startTime[1]}分 ～ {endTime[0]}時{endTime[1]}分
        </span>
      )
    }
  };

  const getStartTimeRange = () => {
    if (!!startTimeRangeStart && !!startTimeRangeEnd) {
      if (startTimeRangeStart[0] === '' || startTimeRangeStart[1] === '' || startTimeRangeEnd[0] === '' || startTimeRangeEnd[1] === '') {
        return NOT_FILL;
      } else {
        return (
          <span className=''>
            {startTimeRangeStart[0]}時{startTimeRangeStart[1]}分 ～ {startTimeRangeEnd[0]}時{startTimeRangeEnd[1]}分
          </span>
        )
      }
    }
  };

  const getEndTimeRange = () => {
    if (!!endTimeRangeStart && !!endTimeRangeEnd) {
      if (endTimeRangeStart[0] === '' || endTimeRangeStart[1] === '' || endTimeRangeEnd[0] === '' || endTimeRangeEnd[1] === '') {
        return NOT_FILL;
      } else {
        return (
          <span className=''>
            {endTimeRangeStart[0]}時{endTimeRangeStart[1]}分 ～ {endTimeRangeEnd[0]}時{endTimeRangeEnd[1]}分
          </span>
        )
      }
    }
  };

  const getOverTimeRange = () => {
    if (!!overTimeRange) {
      return (
        <span className=''>
          {overTimeRange[0]}時間 ～ {overTimeRange[1]}時間
        </span>
      )
    }
  };

  const getWorkDay = () => {
    if(workingDayRangeOthers) {
      return (workingDayCmnt)
    } else {
      return (
        '平日週' + workingDayRange[0] + '日 ～ ' + workingDayRange[1] +'日'
      )
    }
  };

  const getAttendance = () => {
    if(attendance.length === 0) return NOT_FILL;
    let str = getChoiceValues('attendanceList')
      .filter(v => attendance.includes(v))
      .map(v => getChoiceLabel('attendanceList', v))
      .join('\n\n');

    if (attendance.includes("03")) {
      var temp = getChoiceLabel('remoteWorkCountList', remoteWorkCount);
      str += `\n・${temp}`;
    }
    return <>{str}</>;
  };

  const getSalary = () => {
    if (hourSalaryMax !== 0) {
      return (
        <span className=''>
          {hourSalaryMin}
          {' '}
          ～
          {' '}
          {hourSalaryMax}
          {' '}
          円/時間
        </span>
      )
    } else {
      return REQUIRE;
    }
  };

  const getWelfare = () => {
    let str = getChoiceValues('welfareList')
      .filter(w => welfare.includes(w))
      .map(w => getChoiceLabel('welfareList', w))
      .join(' / ');

    if (welfareCmnt !== '') {
      str += '\n\n「その他」' + welfareCmnt;
    }
    return (str);
  };

  const getWorkEnvi = () => {
    const str = getChoiceValues('workEnviList')
      .filter(w => workEnvi.includes(w))
      .map(w => getChoiceLabel('workEnviList', w))
      .join(' / ');
    return (str === '' ? NOT_FILL : str);
  };

  const getAgeRange = () => {
    return (ageRange[0] + '代～' + ageRange[1] + '代')
  };
  const getGenderRange = () => {
    var str = ''
    if (genderRange === '02' || genderRange === '04') {
      str +=
        genderRange === '02' ? 'やや男性が多い' :
          genderRange === '04' ? 'やや女性が多い' : '';
    } else {
      str += getChoiceLabel('genderRangeList', genderRange);
    }
    return (str);
  };

  const getWorkEnviCmnt = () => {
    return (
      <span>
        {workEnviCmnt === '' ? NOT_FILL : <label>{workEnviCmnt}</label>}
      </span>
    );
  };

  // 画面項目メソッド呼び出し
  // 募集背景・業務・スキル
  const showBgdOfRecruitment = getBgdOfRecruitment();
  const showDesiredStartDate = getDesiredStartDate();
  const showWorkPeriod = getWorkPeriod();
  const showDuty = getDuty();
  const showJD = getJD();
  const showWICCmnt = getWICCmnt();
  const showExcel = getExcel();
  const showOtherSkill = getOtherSkill();
  const showSkillOtherCmnt = getSkillOtherCmnt();

  // 勤務条件リスト
  const showWorkTime = getWorkTime();
  const showStartTimeRange = getStartTimeRange();
  const showEndTimeRange = getEndTimeRange();
  const showOverTimeRange = getOverTimeRange();
  const showWorkDay = getWorkDay();
  const showAttendance = getAttendance();
  const showSalary = getSalary();

  // 職務情報リスト
  const showWelfare = getWelfare();
  const showWorkEnvi = getWorkEnvi();
  const showAgeRange = getAgeRange();
  const showGenderRange = getGenderRange();
  const showWorkEnviCmnt = getWorkEnviCmnt();

  // 画面表示リスト
  // 募集背景・業務・スキル
  const jdList = [
    // 募集背景
    {
      text: ADD_CONF_OD_TITLE_TEXT.bgdOfRecruitment,
      children: showBgdOfRecruitment,
      modifyLinks: changeBgdOfRecruitment,
    },
    // 就業開始日
    {
      text: ADD_CONF_OD_TITLE_TEXT.desiredStartDate,
      children: showDesiredStartDate,
      modifyLinks: changeDesiredStartTime,
    },
    // 就業期間
    {
      text: ADD_CONF_OD_TITLE_TEXT.workPeriod,
      children: showWorkPeriod,
      modifyLinks: changeWorkPeriod,
    },
    // 職種
    {
      text: ADD_CONF_OD_TITLE_TEXT.duty,
      children: showDuty,
      modifyLinks: changeDuty,
    },
    // 業務内容
    {
      text: ADD_CONF_OD_TITLE_TEXT.jd,
      children: showJD,
      modifyLinks: changeWIC,
    },
    // 業務内容_その他
    {
      text: isSp ? '業務内容（自由入力）' : '業務内容\n（自由入力）',
      children: showWICCmnt,
      modifyLinks: changeWICCmnt,
    },
    // Excelスキル
    {
      text: ADD_CONF_OD_TITLE_TEXT.excelSkill,
      children: showExcel,
      modifyLinks: changeExcelSkill,
    },
    // その他スキル
    {
      text: ADD_CONF_OD_TITLE_TEXT.otherSkill,
      children: showOtherSkill,
      modifyLinks: changeOtherSkill,
    },
    // その他スキルフリー入力
    {
      text: isSp ? 'その他スキル（自由入力）' : 'その他スキル\n（自由入力）',
      children: showSkillOtherCmnt,
      modifyLinks: changeSkillOtherCmnt,
    },
  ];
  // 勤務条件リスト
  const workDetailList = [
    // 派遣先最寄り駅
    {
      text: CHOICES_NAME_MAP.ekiName,
      children: ekiName,
      modifyLinks: changeEkiName,
    },
    // 勤務時間
    {
      text: ADD_CONF_OD_TITLE_TEXT.workTime,
      children: showWorkTime,
      modifyLinks: changeWorkTime,
    },
    // 始業時間の調整可能範囲
    {
      text: isSp ? '始業時間の調整可能範囲' : '始業時間の\n調整可能範囲',
      children: showStartTimeRange,
      modifyLinks: changeStartTimeRange,
    },
    // 終業時間の調整可能範囲
    {
      text: isSp ? '終業時間の調整可能範囲' : '終業時間の\n調整可能範囲',
      children: showEndTimeRange,
      modifyLinks: changeEndTimeRange,
    },
    // 月の想定残業時間
    {
      text: '月の想定残業時間',
      children: showOverTimeRange,
      modifyLinks: changeOverTime,
    },
    // 勤務日数の調整可能範囲
    {
      text: isSp ? '勤務日数の調整可能範囲' : '勤務日数の\n調整可能範囲',
      children: showWorkDay,
      modifyLinks: changeWorkDay,
    },
    // 勤務条件
    {
      text: ADD_CONF_OD_TITLE_TEXT.attendance,
      children: showAttendance,
      modifyLinks: changeAttendance,
    },
    // 請求金額
    {
      text: ADD_CONF_OD_TITLE_TEXT.salary,
      children: showSalary,
      modifyLinks: changeSalary,
    },
  ];
  // 職務情報リスト
  const jobInfoList = [
    // 福利厚生
    {
      text: isSp ? '利用可能な福利厚生施設' : '利用可能な\n福利厚生施設',
      children: showWelfare,
      modifyLinks: changeWelfare,
    },
    // 職場環境の特徴
    {
      text: isSp ? '職場の特徴（複数選択可）' : '職場の特徴\n（複数選択可）',
      children: showWorkEnvi,
      modifyLinks: changeWorkEnvi,
    },
    // 職場の年齢層
    {
      text: ADD_CONF_OD_TITLE_TEXT.ageRange,
      children: showAgeRange,
      modifyLinks: changeAgeRange,
    },
    // 男女比率
    {
      text: ADD_CONF_OD_TITLE_TEXT.genderRange,
      children: showGenderRange,
      modifyLinks: changeGenderRange,
    },
    // 職場環境_その他
    {
      text: isSp ? '職場環境（自由入力）' : '職場環境\n（自由入力）',
      children: showWorkEnviCmnt,
      modifyLinks: changeWorkEnviCmnt,
    },
  ];
  // 勤務条件リスト
  const basicInfoList = [
    // 企業名
    {
      text: CHOICES_NAME_MAP.companyNameText,
      children: companyNameText,
      modifyLinks: changeCompanyNameText,
    },
    // 派遣先部課名
    {
      text: CHOICES_NAME_MAP.dept,
      children: dept,
      modifyLinks: changeDept,
    },
    // ご担当者名
    {
      text: CHOICES_NAME_MAP.chargePersonNameText,
      children: chargePersonNameText,
      modifyLinks: changeChargePersonNameText,
    },
    // 電話番号
    {
      text: CHOICES_NAME_MAP.tel,
      children: tel,
      modifyLinks: changeTel,
    },
    // メールアドレス
    {
      text: CHOICES_NAME_MAP.email,
      children: email,
      modifyLinks: changeEmail,
    },
    // 派遣先住所
    {
      text: CHOICES_NAME_MAP.address,
      children: address,
      modifyLinks: changeAddress,
    },

    // 紹介予定派遣
    {
      text: isSp ? '紹介予定派遣のみの希望' : '紹介予定派遣のみ\nの希望',
      children: '紹介予定派遣のみを' + (employmentPlacementDispatching ? '希望する' : '希望しない'),
      modifyLinks: changeEmploymentPlacementDispatching,
    },
  ];

  // 職務情報リスト
  const confTitleList = [
    // 募集背景・業務・スキル
    {
      text: ADD_CONF_OD_TITLE_TEXT.jdTitle,
      list: jdList,
      icon: 'icon_basic_info',
      comment: '',
    },
    // 勤務条件コンポーネント
    {
      text: ADD_CONF_OD_TITLE_TEXT.workDetail,
      list: workDetailList,
      icon: 'icon_kinmukeitai',
      comment: '',
    },
    // 職場情報コンポーネント
    {
      text: ADD_CONF_OD_TITLE_TEXT.jobInfo,
      list: jobInfoList,
      icon: 'icon_syokumunaiyou',
      comment: '',
    },
    // 基本情報
    {
      text: ADD_CONF_OD_TITLE_TEXT.basicInfo,
      list: basicInfoList,
      icon: 'icon_basic_info',
      comment: '',
    },
  ];

  const modalList = [
    // 募集背景
    {
      key: 'bgdOfRecruitment',
      modalIsOpen: isOpenBgdOfRecruitment,
      content: contentBgdOfRecruitment,
      button: buttonBgdOfRecruitment,
      onClickCloseButton: isCloseBgdOfRecruitment,
    },
    // 就業開始時期
    {
      key: 'desiredStartTime',
      modalIsOpen: isOpenDesiredStartTime,
      content: contentDesiredStartTime,
      button: buttonDesiredStartTime,
      onClickCloseButton: isCloseDesiredStartTime,
    },
    // 就業期間
    {
      key: 'workPeriod',
      modalIsOpen: isOpenWorkPeriod,
      content: contentWorkPeriod,
      button: buttonWorkPeriod,
      onClickCloseButton: isCloseWorkPeriod,
    },
    // 職種
    {
      key: 'duty',
      modalIsOpen: isOpenDuty,
      content: contentDuty,
      button: buttonDuty,
      onClickCloseButton: isCloseDuty,
    },
    // 業務内容
    {
      key: 'workInfo',
      modalIsOpen: isOpenWorkInfo,
      content: contentWorkInfoModal,
      button: buttonWorkInfoModal,
      onClickCloseButton: isCloseWorkInfoModal,
      onClickBackButton: onClickBackWorkInfoModal,
      max: apiSkillList.length,
      current: _modalWICCurrent + 1,
      mdName: "業務内容を選択する",
      style: 2,
    },
    // 業務内容その他
    {
      key: 'wICCmnt',
      modalIsOpen: isOpenWICCmnt,
      errorDispMessages: dispErrors()._modalWICCmnt,
      content: contentWICCmnt,
      button: buttonWICCmnt,
      onClickCloseButton: isCloseWICCmnt,
    },
    // Excelスキル
    {
      key: 'excelSkill',
      modalIsOpen: isOpenExcelSkill,
      content: contentExcelSkill,
      button: buttonExcelSkill,
      onClickCloseButton: isCloseExcelSkill,
    },
    // その他スキル
    {
      key: 'otherSkill',
      modalIsOpen: isOpenOtherSkill,
      content: contentOtherSkill,
      button: buttonOtherSkill,
      onClickCloseButton: isCloseOtherSkill,
    },
    // その他スキルフリー入力
    {
      key: 'skillOtherCmnt',
      modalIsOpen: isOpenSkillOtherCmnt,
      errorDispMessages: dispErrors()._modalSkillOtherCmnt,
      content: contentSkillOtherCmnt,
      button: buttonSkillOtherCmnt,
      onClickCloseButton: isCloseSkillOtherCmnt,
    },
    // // //
    // 派遣先最寄り駅
    {
      key: 'ekiName',
      modalIsOpen: isOpenEkiName,
      content: contentEkiName,
      errorDispMessages: dispErrors()._modalEkiName,
      button: buttonEkiName,
      onClickCloseButton: isCloseEkiName,
    },
    // 勤務時間
    {
      key: 'workTime',
      modalIsOpen: isOpenWorkTime,
      content: contentWorkTime,
      button: buttonWorkTime,
      onClickCloseButton: isCloseWorkTime,
    },
    // 始業時間の調整可能範囲
    {
      key: 'startTimeRange',
      modalIsOpen: isOpenStartTimeRange,
      content: contentStartTimeRange,
      button: buttonStartTimeRange,
      onClickCloseButton: isCloseStartTimeRange,
    },
    // 終業時間の調整可能範囲
    {
      key: 'endTimeRange',
      modalIsOpen: isOpenEndTimeRange,
      content: contentEndTimeRange,
      button: buttonEndTimeRange,
      onClickCloseButton: isCloseEndTimeRange,
    },
    // 月の想定残業時間
    {
      key: 'overTime',
      modalIsOpen: isOpenOverTime,
      content: contentOverTime,
      button: buttonOverTime,
      onClickCloseButton: isCloseOverTime,
    },
    // 勤務日数の調整可能範囲
    {
      key: 'workDay',
      modalIsOpen: isOpenWorkDay,
      errorDispMessages: dispErrors().attendance,
      content: contentWorkDay,
      button: buttonWorkDay,
      onClickCloseButton: isCloseWorkDay,
    },
    // 勤務条件 テレワーク
    {
      key: 'attendance',
      modalIsOpen: isOpenAttendance,
      errorDispMessages: dispErrors().remoteWorkCount,
      content: contentAttendance,
      button: buttonAttendance,
      onClickCloseButton: isCloseAttendance,
    },
    // 請求金額
    {
      key: 'salary',
      modalIsOpen: isOpenSalary,
      content: contentSalary,
      button: buttonSalary,
      onClickCloseButton: isCloseSalary,
    },
    // 福利厚生
    {
      key: 'welfare',
      modalIsOpen: isOpenWelfare,
      errorDispMessages: dispErrors()._modalWelfare,
      content: contentWelfare,
      button: buttonWelfare,
      onClickCloseButton: isCloseWelfare,
    },
    // 職場環境の特徴
    {
      key: 'workEnvi',
      modalIsOpen: isOpenWorkEnvi,
      errorDispMessages: dispErrors()._modalWorkEnvi,
      content: contentWorkEnvi,
      button: buttonWorkEnvi,
      onClickCloseButton: isCloseWorkEnvi,
    },
    // 職場の年齢層
    {
      key: 'ageRange',
      modalIsOpen: isOpenAgeRange,
      content: contentAgeRange,
      button: buttonAgeRange,
      onClickCloseButton: isCloseAgeRange,
    },
    // 男女比率
    {
      key: 'genderRange',
      modalIsOpen: isOpenGenderRange,
      content: contentGenderRange,
      button: buttonGenderRange,
      onClickCloseButton: isCloseGenderRange,
    },
    // 職場環境_その他
    {
      key: 'workEnviCmnt',
      modalIsOpen: isOpenWorkEnviCmnt,
      errorDispMessages: dispErrors()._modalWorkEnviCmnt,
      content: contentWorkEnviCmnt,
      button: buttonWorkEnviCmnt,
      onClickCloseButton: isCloseWorkEnviCmnt,
    },
    // 企業名
    {
      key: 'companyNameText',
      modalIsOpen: isOpenCompanyNameText,
      content: contentCompanyNameText,
      errorDispMessages: dispErrors()._modalCompanyNameText,
      button: buttonCompanyNameText,
      onClickCloseButton: isCloseCompanyNameText,
    },
    // 派遣先部課名
    {
      key: 'dept',
      modalIsOpen: isOpenDept,
      content: contentDept,
      errorDispMessages: dispErrors()._modalDept,
      button: buttonDept,
      onClickCloseButton: isCloseDept,
    },
    // ご担当者名
    {
      key: 'chargePersonNameText',
      modalIsOpen: isOpenChargePersonNameText,
      content: contentChargePersonNameText,
      errorDispMessages: dispErrors()._modalChargePersonNameText,
      button: buttonChargePersonNameText,
      onClickCloseButton: isCloseChargePersonNameText,
    },
    // 電話番号
    {
      key: 'tel',
      modalIsOpen: isOpenTel,
      content: contentTel,
      errorDispMessages: dispErrors()._modalTel,
      button: buttonTel,
      onClickCloseButton: isCloseTel,
    },
    // メールアドレス
    {
      key: 'email',
      modalIsOpen: isOpenEmail,
      content: contentEmail,
      errorDispMessages: dispErrors()._modalEmail,
      button: buttonEmail,
      onClickCloseButton: isCloseEmail,
    },
    // 派遣先住所
    {
      key: 'address',
      modalIsOpen: isOpenAddress,
      content: contentAddress,
      errorDispMessages: dispErrors()._modalAddress,
      button: buttonAddress,
      onClickCloseButton: isCloseAddress,
    },
    // 紹介予定派遣の希望
    {
      key: 'employmentPlacementDispatching',
      modalIsOpen: isOpenEmploymentPlacementDispatching,
      content: contentEmploymentPlacementDispatching,
      button: buttonEmploymentPlacementDispatching,
      onClickCloseButton: isCloseEmploymentPlacementDispatching,
    },
  ];

  // ボタン押下
  // state更新処理  
  const updState = () =>{
    dispatch({
      type: UPDATE_ADD_CONF,
      updAddConf: {
        // AddInput
        bgdOfRecruitment,
        bgdOfRecruitmentCmnt,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        workPeriodDate,

        // AddJobDescription
        duty,
        dutyCmnt,
        workInfoContent,
        workInfoContentCmnt,
        apiSkillList,

        // AddSkill
        excelSkill,
        otherSkills,
        skillOtherCmnt,

        // AddCondition
        ekiCd,
        ekiName,
        startTime,
        endTime,
        startTimeRangeStart,
        startTimeRangeEnd,
        endTimeRangeStart,
        endTimeRangeEnd,
        overTimeRange,
        workingDayRange,
        workingDayRangeOthers,
        workingDayCmnt,
        attendance,
        remoteWorkCount,
        hourSalaryMin,
        hourSalaryMax,

        // AddEnvi
        welfare,
        welfareCmnt,
        workEnvi,
        ageRange,
        genderRange,
        workEnviCmnt,

        // AddInfo
        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        employmentPlacementDispatching,

        otherComment,
      },
    });
  };

  const onClickMainButton = {
    prev: () => {
      scrollTop();
      updState();
      dispatch({
        type: CHANGE_VALID,
        path,
        valid,
      });
    },
    next: (e) => {
      // イベント計測
      MeasureEvent(
        {
          linkTrackVars: MEASURE_MAP.EVENT_85.linkTrackVars,
          linkTrackEvents: MEASURE_MAP.EVENT_85.linkTrackEvents,
          events: MEASURE_MAP.EVENT_85.events,
        },
        MEASURE_MAP.EVENT_85.name,
      );
      scrollTop();
      updState();
      setShowLoding(true);

      // 依頼IDを保存
      dispatch({
        type: UPDATE_RECEIPT_ID,
        updReceiptID: { receiptID },
      });

      // MAKE PARAM
      const paramBgdOfRecruitment = () => {
        const target = CHOICES_MAP.bgdOfRecruitmentList.find(v=>v.value === bgdOfRecruitment);
        return bgdOfRecruitment === COMMENT_MAP.bgdOfRecruitmentCmnt.value? bgdOfRecruitmentCmnt : target.label;
      };
      const paramDesiredStartDate = () => {
        const target = CHOICES_MAP.desiredStartDateKubunList.find(v=>v.value === desiredStartDateKubun);
        return desiredStartDateKubun === '03' ? desiredStartDate : target.label;
      };
      const paramWorkPeriod = () => {
        const target = CHOICES_MAP.workPeriodList.find(v=>v.value === workPeriod);
        return workPeriod === '01' ? workPeriodDate : target.label;
      };
      const paramWorkInfo = () => {
        return workInfoContentCmnt === '' ? showJD : showJD + '\n\n＜その他＞\n' + workInfoContentCmnt;
      };
      const paramOtherSkill = () => {
        let str = '';
        if(otherSkills.length !== 0) {
          str += showOtherSkill;
        }
        if(skillOtherCmnt !== '') {
          str += '\n\n＜その他スキル（自由入力）＞\n' + skillOtherCmnt;
        }
        return str;
      };
      const paramWorkTime = () => {
        let str = '（勤務時間）\n' + startTime[0] + ':' + startTime[1] + '～' + endTime[0] + ':' + endTime[1];

        str += '\n\n（始業時間の調整可能範囲）\n';
        if (startTimeRangeStart[0] === '' || startTimeRangeStart[1] === '' || startTimeRangeEnd[0] === '' || startTimeRangeEnd[1] === '') {
          str += '\n';
        } else {
          str += startTimeRangeStart[0] + ':' + startTimeRangeStart[1] + '～' + startTimeRangeEnd[0] + ':' + startTimeRangeEnd[1] + '\n';
        }

        str += '\n（終業時間の調整可能範囲）\n';
        if (endTimeRangeStart[0] === '' || endTimeRangeStart[1] === '' || endTimeRangeEnd[0] === '' || endTimeRangeEnd[1] === '') {
          str += '\n';
        } else {
          str += endTimeRangeStart[0] + ':' + endTimeRangeStart[1] + '～' + endTimeRangeEnd[0] + ':' + endTimeRangeEnd[1] + '\n';
        }

        str += '\n（うち休憩時間）\n・60分';

        return str;
      };
      const paramWorkingConditions = () => {
        let str = '＜休日出勤有無＞\n';
        str += attendance.includes('01') ? '休日勤務あり' : 'なし';

        str += '\n\n＜祝日出勤有無＞\n';
        str += attendance.includes('02') ? '祝日勤務あり' : 'なし';

        str += '\n\n＜派遣スタッフのテレワークは可能ですか＞\n';
        str += attendance.includes('03') ? '可能\n\n(テレワーク頻度)\n' + getChoiceLabel('remoteWorkCountList', remoteWorkCount) : '不可';

        return str;
      };

      const params = {
        bgdOfRecruitment: paramBgdOfRecruitment(),
        desiredStartDate: paramDesiredStartDate(),
        strWorkPeriod: paramWorkPeriod(),
        workCategory: showDuty,
        strWorkInfo: paramWorkInfo(),
        excelSkill: showExcel,
        strOtherSkill: paramOtherSkill(),

        ekiName,
        ekiCd,
        strWorkTime: paramWorkTime(),
        overtimeHoursMin: Number(overTimeRange[0]),
        overtimeHoursMax: Number(overTimeRange[1]),
        strDayOfTheWeek: showWorkDay,
        WorkingConditions: paramWorkingConditions(),
        hourSalaryMin,
        hourSalaryMax,
        welfare: showWelfare,
        workEnvi: workEnvi.length !== 0 ? showWorkEnvi : '',
        ageRange: showAgeRange,
        genderRange: showGenderRange,
        workEnviCmnt,

        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        employmentPlacementDispatching,

        otherComment,
        receiptID,
        clickID,
        mediaID,
      };

      // データ登録処理
      e.preventDefault();
      // 二重登録
      if(isAddRegistered) {
        setIsApiError(true);
        return false;
      };
      // Postパラメータチェック
      const [ isPostValid ] = isSchemaValid({ path: `${path}:post`, target: params });
      if(!isPostValid){
        setIsApiError(true);
        return false;
      };
      // ok
      dispatch({
        type: CHANGE_VALID,
        path,
        valid: isPostValid,
      });

      // 更新処理
      postRegisterOrderApi({ params })
        .then(() => {
          history.push(ADD_THANKS_URL);
        })
        .catch(err => {
          // FATELエラーチェック
          const isFatal = isFatalApiError(err);
          setIsApiError(isFatal);
          if(isFatal) throw err;

          // 400エラーは基本的に起きないためFATAL
          if(err.response.status === 400) {
            setIsApiError(true);
            return false;
          };
          return false;
        });
      return true;
    },
  };

  // 画面表示
  return isSp ? (
    <PresentSP
      otherComment={otherComment}

      onChangeOtherComment={onChangeOtherComment}

      // 画面項目
      confTitleList={confTitleList}

      // モーダル
      modalList={modalList}

      // onClick
      onClickMainButton={onClickMainButton}

      errorDispMap={dispErrors()}
      isApiError={isApiError}
      showLoading={showLoading}
      valid={valid}
    />
  ) : (
    <PresentPC
      otherComment={otherComment}

      onChangeOtherComment={onChangeOtherComment}

      // 画面項目
      confTitleList={confTitleList}

      // モーダル
      modalList={modalList}

      // onClick
      onClickMainButton={onClickMainButton}

      errorDispMap={dispErrors()}
      isApiError={isApiError}
      showLoading={showLoading}
      valid={valid}

    />
  );
};

export default AddConf;